// import {Center, clsx, Loader, Pagination, Text, Checkbox, Modal, Select} from '@mantine/core'
// import {useContext, useEffect, useMemo, useState} from 'react'
// import {Link, useLocation} from 'react-router-dom'
// import {
//   KTCard,
//   KTCardBody,
//   Message,
//   changeTextCamal,
//   checkRole,
//   getPaginationInfoData,
//   toAbsoluteUrl,
// } from '../../../_metronic/helpers'
// import FeatureGate from '../../components/FeatureGate'
// import {FEATURE_KEYS} from '../../features/featureRegistry'
// import Button from '../../components/Button/Button'
// import roleContext from '../../context/roleContext'
// import {setupAxios, useAuth} from '../../modules/auth'
// import {RoleContextValue} from '../../types/OtherTypes'
// import CreateUser from './CreateUser'
// import BulkUserUpload from './components/BulkUserUpload'
// import {getPartnerUser} from './UserFunction'
// import {api} from '../../../api/APIMiddlewares'
// import API from '../../../api/APIUrl'
// import { getProbationaryUsers, getFullTimeUsers, updateEmploymentStatus, bulkUpdateWorkingShift } from '../../../api/AdminAPI'
// import { getWorkingShifts } from '../../../api/WorkingShiftAPI'
// import { differenceInCalendarDays } from 'date-fns'

// const User = () => {
//   const [isCreateUserModalOpen, setIsCreateUserModalOpen] = useState(false)
//   const {currentUser} = useAuth()
//   const [activeTab, setActiveTab] = useState('Full-Time')
//   const [manageModal, setManageModal] = useState<{open:boolean; user:any|null}>({open:false, user:null})
//   const location = useLocation()
//   const [search, setSearch] = useState('')

//   // Multi-select state for bulk operations
//   const [selectedUsers, setSelectedUsers] = useState<Set<string>>(new Set())
//   const [selectAllOnPage, setSelectAllOnPage] = useState(false)

//   // Working shift modal state
//   const [workingShiftModal, setWorkingShiftModal] = useState(false)
//   const [workingShifts, setWorkingShifts] = useState<{id: string; shiftName: string; startTime: string; endTime: string}[]>([])
//   const [selectedShiftId, setSelectedShiftId] = useState<string | null>(null)
//   const [bulkUpdateLoading, setBulkUpdateLoading] = useState(false)
//   const handleTabClick = (tab) => {
//     if (tab === activeTab) return
//     setActiveTab(tab)
//     setActivePage(1)
//     setSearch('')
//     // Clear selections when switching tabs
//     setSelectedUsers(new Set())
//     setSelectAllOnPage(false)
//   }

//   // Toggle individual user selection
//   const toggleUserSelection = (userId: string) => {
//     setSelectedUsers((prev) => {
//       const newSet = new Set(prev)
//       if (newSet.has(userId)) {
//         newSet.delete(userId)
//       } else {
//         newSet.add(userId)
//       }
//       return newSet
//     })
//   }

//   // Toggle select all on current page
//   const toggleSelectAllOnPage = () => {
//     if (selectAllOnPage) {
//       // Deselect all on current page
//       const currentPageIds = new Set(displayItems.map((u: any) => u.id))
//       setSelectedUsers((prev) => {
//         const newSet = new Set(prev)
//         currentPageIds.forEach((id) => newSet.delete(id))
//         return newSet
//       })
//       setSelectAllOnPage(false)
//     } else {
//       // Select all on current page
//       const currentPageIds = displayItems.map((u: any) => u.id)
//       setSelectedUsers((prev) => {
//         const newSet = new Set(prev)
//         currentPageIds.forEach((id) => newSet.add(id))
//         return newSet
//       })
//       setSelectAllOnPage(true)
//     }
//   }

//   // Open working shift modal
//   const openWorkingShiftModal = async () => {
//     try {
//       const res = await getWorkingShifts(true)
//       if (res.statusCode === 200) {
//         setWorkingShifts(res.data || [])
//       } else {
//         setWorkingShifts([])
//       }
//     } catch (error) {
//       console.error('Error fetching working shifts:', error)
//       setWorkingShifts([])
//     }
//     setWorkingShiftModal(true)
//     setSelectedShiftId(null)
//   }

//   // Handle bulk working shift update
//   const handleBulkWorkingShiftUpdate = async () => {
//     if (!selectedShiftId || selectedUsers.size === 0) {
//       Message('Please select a working shift and at least one user', 'error')
//       return
//     }

//     setBulkUpdateLoading(true)
//     try {
//       const userIds = Array.from(selectedUsers)
//       const res = await bulkUpdateWorkingShift(userIds, selectedShiftId)

//       if (res.statusCode === 200) {
//         Message(res.message || `Successfully updated working shift for ${userIds.length} user(s)`, 'success')
//         setWorkingShiftModal(false)
//         setSelectedUsers(new Set())
//         setSelectAllOnPage(false)
//         setSelectedShiftId(null)
//         fetchUsers()
//       } else {
//         Message(res.message || 'Failed to update working shifts', 'error')
//       }
//     } catch (error: any) {
//       console.error('Error updating working shifts:', error)
//       Message(error?.message || 'Failed to update working shifts', 'error')
//     } finally {
//       setBulkUpdateLoading(false)
//     }
//   }
//   const [activePage, setActivePage] = useState(1)
//   const [rowsPerPage, setRowsPerPage] = useState<number>(() => {
//     const saved = sessionStorage.getItem('users_rows_per_page')
//     const parsed = saved ? parseInt(saved) : 10
//     return [10, 25, 50, 100].includes(parsed) ? parsed : 10
//   })
//   const [sortBy, setSortBy] = useState<string>('createdAt')
//   const [sortDir, setSortDir] = useState<'asc' | 'desc'>('desc')
//   const serverSortableKeys = useMemo(() => new Set(['firstName', 'lastName', 'email', 'mobile', 'createdAt', 'joiningDate', 'status']), [])
//   const clientSortableKeys = useMemo(() => new Set(['designation', 'employment', 'role']), [])
//   const cycleSort = (key: string) => {
//     if (sortBy !== key) {
//       setSortBy(key)
//       setSortDir('asc')
//       setActivePage(1)
//       return
//     }
//     if (sortDir === 'asc') {
//       setSortDir('desc')
//       setActivePage(1)
//       return
//     }
//     // Reset to default (no sort on this column)
//     setSortBy('createdAt')
//     setSortDir('desc')
//     setActivePage(1)
//   }
//   let roleState: RoleContextValue = useContext(roleContext)

//   // Check if user can perform bulk operations (Admin, Super Admin, HR, RM)
//   const canBulkUpdate = useMemo(() => {
//     return currentUser?.isAdmin === true || 
//            currentUser?.isRmOrHr === true ||
//            checkRole(['Users Registration', 'Roles', 'General Config'], roleState.features)
//   }, [currentUser, roleState.features])

//   const [user, setUser] = useState<{
//     items: {
//       id: string
//       firstName: string
//       lastName: string
//       email: string
//       mobile: string
//       password: string
//       dob: string
//       gender: string
//       employment: string
//       employmentStatus?: string
//       designation: string
//       startDate: string
//       endDate: string
//       joiningDate?: string
//       probationEndDate?: string
//       userRoles: string[]
//       inTime: string
//       outTime: string
//       reportingManager: {
//         firstName: string
//         lastName: string
//       }
//       hrManager: {
//         firstName: string
//         lastName: string
//       }
//       associates: {
//         associateType: string
//         userAssociate: {id: string; firstName: string; lastName: string}
//       }[]
//       personalEmail: string
//       salaryStrucutre: string
//     }[]

//     limit: number
//     page: number
//     total: number
//   }>({items: [], limit: 10, page: 1, total: 0})
//   const [APIStatus, setAPIStatus] = useState({
//     loading: false,
//     error: null,
//   })
//   const [isBulkUploadOpen, setIsBulkUploadOpen] = useState(false)
//   // Debounced live search (reset to page 1)
//   useEffect(() => {
//     if (!search) return
//     const handler = setTimeout(() => {
//       setActivePage(1)
//       fetchUsers()
//     }, 400)
//     return () => clearTimeout(handler)
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [search])

//   // Sync tab from query param (?tab=Probationary|Full-Time)
//   useEffect(() => {
//     const params = new URLSearchParams(location.search)
//     const tab = params.get('tab')
//     if (tab && ['Active','Inactive','Probationary','Full-Time'].includes(tab)) {
//       setActiveTab(tab)
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [])
//   const getUser = (setUser: Function, setAPIStatus: Function, page: number, status: string) => {
//     let {token, tenantId} = setupAxios()
//     setAPIStatus((prev: any) => ({...prev, loading: true}))
//     const baseUrl = `/${API.USER}?preset=full&page=${page}&limit=${rowsPerPage}&status=${status}`
//     const searchParam = search ? `&search=${encodeURIComponent(search)}` : ''
//     const sortParams = serverSortableKeys.has(sortBy)
//       ? `&sortBy=${encodeURIComponent(sortBy)}&sort=${encodeURIComponent(sortDir)}`
//       : ''

//     api
//       .get(
//         `${baseUrl}${searchParam}${sortParams}`,
//         token,
//         tenantId,
//         false
//       )
//       .then((res) => {
//         if (res.statusCode === 200) {
//           setUser(res?.data)
//           setAPIStatus((prev: any) => ({...prev, loading: false, error: null}))
//         } else {
//           setUser({items: [], limit: 10, page: 1, total: 0})
//           setAPIStatus((prev: any) => ({...prev, loading: false, error: res.message}))
//         }
//       })
//       .catch((error) => {
//         // Handle error silently or use proper error handling
//       })
//   }
//   const fetchUsers = () => {
//     const statusParam = activeTab === 'Full-Time' ? 'Full-Time' : activeTab === 'Probationary' ? 'Probationary' : activeTab
//     return getUser(setUser, setAPIStatus, activePage, statusParam)
//   }
//   const displayItems = useMemo(() => {
//     const items = user?.items || []
//     if (!clientSortableKeys.has(sortBy)) return items
//     const dir = sortDir === 'asc' ? 1 : -1
//     const getVal = (obj: any): string => {
//       if (sortBy === 'designation') return (obj?.designation || '').toString()
//       if (sortBy === 'employment') return (obj?.employment || '').toString()
//       if (sortBy === 'role') return (obj?.userRoles || []).join(',')
//       return ''
//     }
//     return [...items].sort((a, b) => getVal(a).localeCompare(getVal(b)) * dir)
//   }, [user?.items, sortBy, sortDir, clientSortableKeys, activeTab])
//   // Refetch on tab/page/rows/sort change (server-side pagination)
//   useEffect(() => {
//     fetchUsers()
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [activeTab, activePage, rowsPerPage, sortBy, sortDir])

//   // Update selectAllOnPage state when displayItems or selectedUsers changes
//   useEffect(() => {
//     if (displayItems.length === 0) {
//       setSelectAllOnPage(false)
//       return
//     }
//     const allOnPageSelected = displayItems.every((u: any) => selectedUsers.has(u.id))
//     setSelectAllOnPage(allOnPageSelected)
//   }, [displayItems, selectedUsers])

//   return (
//     <>
//       {' '}
//       <div>
//         <div
//           // id='kt_toolbar_container'
//           className={clsx('d-flex justify-content-between align-items-center mb-4')}
//         >
//           <div className='d-flex h-55px'>
//             <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap'>
//               <FeatureGate feature={FEATURE_KEYS.users_active_list}>
//                 <li className='nav-item'>
//                   <Link
//                     className={clsx('nav-link text-active-primary me-4', {
//                       active: activeTab === 'Active',
//                     })}
//                     to=''
//                     onClick={() => handleTabClick('Active')}
//                   >
//                     Active
//                   </Link>
//                 </li>
//               </FeatureGate>

//               <FeatureGate feature={FEATURE_KEYS.users_inactive_list}>
//                 <li className='nav-item'>
//                   <Link
//                     className={clsx('nav-link text-active-primary me-4', {
//                       active: activeTab === 'Inactive',
//                     })}
//                     to=''
//                     onClick={() => handleTabClick('Inactive')}
//                   >
//                     Inactive
//                   </Link>
//                 </li>
//               </FeatureGate>

//               {currentUser?.isRmOrHr && (
//                 <>
//                   <li className='nav-item'>
//                     <Link
//                       className={clsx('nav-link text-active-primary me-4', {
//                         active: activeTab === 'Full-Time',
//                       })}
//                       to=''
//                       onClick={() => handleTabClick('Full-Time')}
//                     >
//                       Full-Time
//                     </Link>
//                   </li>
//                   <li className='nav-item'>
//                     <Link
//                       className={clsx('nav-link text-active-primary me-4', {
//                         active: activeTab === 'Probationary',
//                       })}
//                       to=''
//                       onClick={() => handleTabClick('Probationary')}
//                     >
//                       Probationary
//                     </Link>
//                   </li>
//                 </>
//               )}
//             </ul>
//           </div>
//           <div className='d-flex align-items-center me-5'>
//             <input
//               type='text'
//               className='form-control form-control-sm'
//               placeholder='Search users...'
//               value={search}
//               onChange={(e) => setSearch(e.target.value)}
//               onKeyDown={(e) => {
//                 if (e.key === 'Enter') {
//                   setActivePage(1)
//                   fetchUsers()
//                 }
//               }}
//               style={{width: '260px'}}
//             />
//             {/* Search button removed; live search triggers on typing */}
//           </div>
//         </div>
//       </div>
//       <KTCard>
//         <div className='card-header'>
//           <div className='card-title'>{activeTab} Users</div>
//           <div className='card-toolbar'>
//             <div className='d-flex justify-content-end align-items-center' data-kt-user-table-toolbar='base'>
//               {/* Bulk Update Working Shift Button */}
//               {canBulkUpdate && selectedUsers.size > 0 && (
//                 <Button
//                   variant='warning'
//                   size='sm'
//                   leftIcon={<i className='fas fa-clock'></i>}
//                   onClick={openWorkingShiftModal}
//                   className='me-2'
//                 >
//                   Update Shift ({selectedUsers.size} selected)
//                 </Button>
//               )}
//               {canBulkUpdate && selectedUsers.size > 0 && (
//                 <Button
//                   variant='light'
//                   size='sm'
//                   onClick={() => {
//                     setSelectedUsers(new Set())
//                     setSelectAllOnPage(false)
//                   }}
//                   className='me-2'
//                 >
//                   Clear Selection
//                 </Button>
//               )}
//               <FeatureGate feature={FEATURE_KEYS.users_list}>
//                 <Button
//                   variant='secondary'
//                   size='sm'
//                   leftIcon={<i className='fas fa-file-upload'></i>}
//                   hidden={activeTab === 'Inactive'}
//                   onClick={() => setIsBulkUploadOpen(true)}
//                   className='me-2'
//                 >
//                   Upload Users (Excel/CSV)
//                 </Button>
//                 <Button
//                   variant='primary'
//                   size='sm'
//                   leftIcon={<i className='fas fa-plus'></i>}
//                   hidden={activeTab === 'Inactive'}
//                   onClick={() => {
//                     setIsCreateUserModalOpen(true)
//                   }}
//                 >
//                   Add User
//                 </Button>
//               </FeatureGate>
//             </div>
//           </div>
//         </div>
//         <KTCardBody className='py-4'>
//           <div className='table-responsive'>
//             {APIStatus.loading ? (
//               <Center>
//                 {/* Render your loading spinner or indicator here */}
//                 <Loader />
//               </Center>
//             ) : (
//               <table
//                 id='kt_table_users'
//                 className='table align-middle table-row-dashed fs-6 dataTable'
//               >
//                 <thead className=' text-muted fw-bolder fs-7 text-uppercase gs-0 text-start'>
//                   <tr>
//                     {canBulkUpdate && (
//                       <th style={{width: '50px'}}>
//                         <Checkbox
//                           checked={selectAllOnPage && displayItems.length > 0}
//                           indeterminate={selectedUsers.size > 0 && !selectAllOnPage}
//                           onChange={toggleSelectAllOnPage}
//                           title='Select all on this page'
//                         />
//                       </th>
//                     )}
//                     <th></th>
//                     <th role='button' title='Click to sort' onClick={() => cycleSort('firstName')}>
//                       Name {sortBy === 'firstName' ? (sortDir === 'asc' ? '↑' : '↓') : ''}
//                     </th>
//                     <th role='button' title='Click to sort' onClick={() => cycleSort('mobile')}>
//                       Contact {sortBy === 'mobile' ? (sortDir === 'asc' ? '↑' : '↓') : ''}
//                     </th>
//                     <th role='button' title='Click to sort' onClick={() => cycleSort('designation')}>
//                       Designation {sortBy === 'designation' ? (sortDir === 'asc' ? '↑' : '↓') : ''}
//                     </th>
//                     <th role='button' title='Click to sort' onClick={() => cycleSort('employment')}>
//                       Employment Type {sortBy === 'employment' ? (sortDir === 'asc' ? '↑' : '↓') : ''}
//                     </th>
//                     <th role='button' title='Click to sort' onClick={() => cycleSort('role')}>
//                       Role {sortBy === 'role' ? (sortDir === 'asc' ? '↑' : '↓') : ''}
//                     </th>
//                     {activeTab === 'Probationary' ? (
//                       <th>Probation Ends</th>
//                     ) : (
//                       <>
//                         <th>Reporting Manager</th>
//                         <th>Human Resource</th>
//                       </>
//                     )}
//                     <th>Actions</th>
//                   </tr>
//                 </thead>
//                 {displayItems?.length > 0 ? (
//                   <tbody className='text-gray-800 fw-semibold text-left'>
//                     {displayItems?.map((obj) => {
//                       return (
//                         <tr key={obj?.id}>
//                           {canBulkUpdate && (
//                             <td>
//                               <Checkbox
//                                 checked={selectedUsers.has(obj?.id)}
//                                 onChange={() => toggleUserSelection(obj?.id)}
//                               />
//                             </td>
//                           )}
//                           <td className='symbol symbol-45px'>
//                             <img
//                               src={toAbsoluteUrl('/media/avatars/blank.png')}
//                               alt='user profile'
//                             />
//                           </td>
//                           <td style={{minWidth: '70px', paddingLeft: '10px'}}>
//                             {changeTextCamal(obj?.firstName)} {changeTextCamal(obj?.lastName)}{' '}
//                             <br />
//                             <a
//                               className='fs-7'
//                               href={`mailto:${obj?.email}`}
//                               target='_blank'
//                               rel='noopener noreferrer'
//                             >
//                               {obj?.email}
//                             </a>
//                           </td>

//                           <td>{`${obj?.mobile ? '+91' + obj.mobile : '-'}`}</td>

//                           <td>{changeTextCamal(obj?.designation)}</td>
//                           <td>{changeTextCamal(obj?.employment)}</td>
//                           <td>{obj?.userRoles?.map((item) => item)}</td>
//                           {activeTab === 'Probationary' ? (
//                             <td>
//                               {(() => {
//                                 const now = new Date();
//                                 const jd = obj.joiningDate ? new Date(obj.joiningDate) : null as any;
//                                 let pe = obj.probationEndDate ? new Date(obj.probationEndDate) : null as any;
//                                 if (!pe && jd) {
//                                   const d = new Date(jd);
//                                   d.setMonth(d.getMonth() + 6);
//                                   pe = d;
//                                 }
//                                 if (!pe) return '-';
//                                 const days = Math.ceil((pe.getTime() - now.getTime()) / (1000 * 60 * 60 * 24));
//                                 if (days <= 30 && days >= 0) {
//                                   return (
//                                     <span className='badge badge-light-warning'>
//                                       {pe.toLocaleDateString()} ({days} days)
//                                     </span>
//                                   );
//                                 }
//                                 return '-';
//                               })()}
//                             </td>
//                           ) : (
//                             <>
//                               <td style={{minWidth: '70px', paddingLeft: '10px'}}>
//                                 {obj.associates.some((item) => item.associateType === 'RM') ? (
//                                   <span>
//                                     {obj.associates?.map((associate) =>
//                                       associate.associateType === 'RM' ? (
//                                         <>
//                                           {changeTextCamal(associate?.userAssociate?.firstName)}{' '}
//                                           {changeTextCamal(associate?.userAssociate?.lastName)}
//                                         </>
//                                       ) : (
//                                         ''
//                                       )
//                                     )}
//                                   </span>
//                                 ) : (
//                                   '-'
//                                 )}
//                               </td>
//                               <td>
//                                 {obj.associates.some((item) => item.associateType === 'HR') ? (
//                                   <span>
//                                     {obj.associates?.map((associate) =>
//                                       associate.associateType === 'HR' ? (
//                                         <>
//                                           {changeTextCamal(associate?.userAssociate?.firstName)}{' '}
//                                           {changeTextCamal(associate?.userAssociate?.lastName)}
//                                         </>
//                                       ) : (
//                                         ''
//                                       )
//                                     )}
//                                   </span>
//                                 ) : (
//                                   '-'
//                                 )}
//                               </td>
//                             </>
//                           )}

//                           {/* Actions */}
//                           <td>
//                             <div className='d-flex justify-content-center flex-shrink-0'>
//                               {/* Existing actions */}
//                               <Link
//                                 className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
//                                 to={`/profile/${obj?.id}`}
//                               >
//                                 <i className='fas fa-eye'></i>
//                               </Link>

//                               {/* HR/Admin probation manage modal trigger */}
//                               {['Probationary'].includes(activeTab) && (
//                                 (obj.associates?.some((a:any)=> a.associateType==='HR' && currentUser?.id && a.userAssociate && a.userAssociate.id === currentUser.id)) ||
//                                 (currentUser?.isAdmin === true) ||
//                                 (checkRole(['Users Registration','Roles','General Config'], roleState.features))
//                               ) && (
//                                 <>
//                                   {typeof (obj as any).remainingDays === 'number' && (obj as any).remainingDays <= 30 && (
//                                     <span className='badge badge-light-warning me-2'>
//                                       {(obj as any).remainingDays} days left
//                                     </span>
//                                   )}
//                                   <button className='btn btn-sm btn-primary' onClick={()=> setManageModal({open:true, user: obj})}>
//                                     Manage
//                                   </button>
//                                 </>
//                               )}
//                             </div>
//                           </td>
//                         </tr>
//                       )
//                     })}
//                   </tbody>
//                 ) : (
//                   <tbody>
//                     <tr>
//                       <td colSpan={canBulkUpdate ? 10 : 9}>
//                         <Center>
//                           <Text>No users found</Text>
//                         </Center>
//                       </td>
//                     </tr>
//                   </tbody>
//                 )}
//               </table>
//             )}
//           </div>
//           <div className='d-flex mt-4'>
//             <Text className='me-auto'>
//               {getPaginationInfoData(activePage, String(rowsPerPage), user?.total?.toString() ?? '', {
//                 data: user?.items ?? '',
//               })}{' '}
//               Of {Math.ceil(Number(user?.total ?? 0))}
//             </Text>
//             <div className='d-flex align-items-center gap-3'>
//               <div className='d-flex align-items-center'>
//                 <span className='me-2'>Rows:</span>
//                 <select
//                   className='form-select form-select-sm'
//                   value={rowsPerPage}
//                   onChange={(e) => {
//                     const val = parseInt(e.target.value)
//                     sessionStorage.setItem('users_rows_per_page', String(val))
//                     setRowsPerPage(val)
//                     setActivePage(1)
//                   }}
//                 >
//                   {[10,25,50,100].map((n) => (
//                     <option key={n} value={n}>{n}</option>
//                   ))}
//                 </select>
//               </div>
//               <Pagination
//               value={activePage}
//               size='lg'
//               styles={(theme) => ({
//                 control: {
//                   '&[data-active]': {
//                     backgroundImage: theme.colorScheme,
//                   },
//                 },
//               })}
//               onChange={(page) => {
//                 setActivePage(page)
//                 // Use properly mapped status instead of raw activeTab
//                 const statusParam = activeTab === 'Full-Time' ? 'Full-Time' : activeTab === 'Probationary' ? 'Probationary' : activeTab
//                 getUser(setUser, setAPIStatus, page, statusParam)
//               }}
//               total={Math.ceil(Number(user?.total ?? 0) / Number(rowsPerPage))}
//             ></Pagination>
//             </div>
//           </div>
//         </KTCardBody>
//       </KTCard>
//       {isCreateUserModalOpen && (
//         <CreateUser
//           closeModal={() => setIsCreateUserModalOpen(false)}
//           user={user}
//           setUser={setUser}
//           fetchUsers={fetchUsers}
//         />
//       )}
//       {isBulkUploadOpen && (
//         <BulkUserUpload
//           onClose={() => setIsBulkUploadOpen(false)}
//           onUploaded={() => {
//             setIsBulkUploadOpen(false)
//             fetchUsers()
//           }}
//         />
//       )}
//       {manageModal.open && (
//         <div className='modal fade show d-block' tabIndex={-1}>
//           <div className='modal-dialog'>
//             <div className='modal-content'>
//               <div className='modal-header'>
//                 <h5 className='modal-title'>Manage Probation</h5>
//                 <button type='button' className='btn-close' onClick={()=> setManageModal({open:false, user:null})}></button>
//               </div>
//               <div className='modal-body'>
//                 <p className='mb-4'>Choose an action for {changeTextCamal(manageModal.user?.firstName)} {changeTextCamal(manageModal.user?.lastName)}</p>
//                 <div className='d-flex gap-3'>
//                   <label className='btn btn-light-primary'>
//                     <i className='fas fa-upload me-1'></i> Convert to Full-Time (upload docs)
//                     <input type='file' hidden accept='.pdf,.doc,.docx' onChange={async (e)=>{
//                       const file = e.target.files?.[0]
//                       if (!file) return
//                       const res = await updateEmploymentStatus(manageModal.user.id, 'FULL_TIME', file)
//                       if (res.statusCode === 200) {
//                         Message('User marked Full-Time','success')
//                         setManageModal({open:false, user:null})
//                         fetchUsers()
//                       } else {
//                         Message(res.message || 'Failed','error')
//                       }
//                       try { if (e.currentTarget) e.currentTarget.value = '' } catch {}
//                     }}/>
//                   </label>
//                   <button className='btn btn-light-danger' onClick={async ()=>{
//                     const res = await updateEmploymentStatus(manageModal.user.id, 'LAID_OFF')
//                     if (res.statusCode === 200) {
//                       Message('User marked Laid-Off','success')
//                       setManageModal({open:false, user:null})
//                       fetchUsers()
//                     } else {
//                       Message(res.message || 'Failed','error')
//                     }
//                   }}>
//                     <i className='fas fa-user-slash me-1'></i> Lay Off
//                   </button>
//                 </div>
//               </div>
//               <div className='modal-footer'>
//                 <button className='btn btn-secondary' onClick={()=> setManageModal({open:false, user:null})}>Close</button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Bulk Update Working Shift Modal */}
//       <Modal
//         opened={workingShiftModal}
//         onClose={() => {
//           setWorkingShiftModal(false)
//           setSelectedShiftId(null)
//         }}
//         title={
//           <div>
//             <h5 className='mb-1'>Update Working Shift</h5>
//             <small className='text-muted'>
//               {selectedUsers.size} user(s) selected
//             </small>
//           </div>
//         }
//         size='md'
//         centered
//       >
//         <div className='mb-4'>
//           <p className='text-muted mb-3'>
//             Select a working shift to apply to all selected users. This will update their shift timing.
//           </p>

//           <Select
//             label='Working Shift'
//             placeholder='Select a working shift'
//             value={selectedShiftId}
//             onChange={(value) => setSelectedShiftId(value)}
//             data={workingShifts.map((shift) => ({
//               value: shift.id,
//               label: `${shift.shiftName} (${shift.startTime} - ${shift.endTime})`,
//             }))}
//             searchable
//             clearable
//             nothingFound='No working shifts found'
//           />

//           {selectedShiftId && (
//             <div className='mt-3 p-3 bg-light rounded'>
//               <small className='text-muted'>Selected shift details:</small>
//               {(() => {
//                 const shift = workingShifts.find((s) => s.id === selectedShiftId)
//                 if (!shift) return null
//                 return (
//                   <div className='mt-2'>
//                     <strong>{shift.shiftName}</strong>
//                     <br />
//                     <span className='text-muted'>
//                       <i className='fas fa-clock me-1'></i>
//                       {shift.startTime} - {shift.endTime}
//                     </span>
//                   </div>
//                 )
//               })()}
//             </div>
//           )}
//         </div>

//         <div className='d-flex justify-content-end gap-2'>
//           <Button
//             variant='light'
//             onClick={() => {
//               setWorkingShiftModal(false)
//               setSelectedShiftId(null)
//             }}
//           >
//             Cancel
//           </Button>
//           <Button
//             variant='primary'
//             onClick={handleBulkWorkingShiftUpdate}
//             disabled={!selectedShiftId || bulkUpdateLoading}
//             loading={bulkUpdateLoading}
//           >
//             Update {selectedUsers.size} User(s)
//           </Button>
//         </div>
//       </Modal>
//     </>
//   )
// }

// export default User
// // import {Center, clsx, Loader, Pagination, Text, Checkbox, Modal, Select} from '@mantine/core'
// // import {useContext, useEffect, useMemo, useState} from 'react'
// // import {Link, useLocation} from 'react-router-dom'
// // import {
// //   KTCard,
// //   KTCardBody,
// //   Message,
// //   changeTextCamal,
// //   checkRole,
// //   getPaginationInfoData,
// //   toAbsoluteUrl,
// // } from '../../../_metronic/helpers'
// // import FeatureGate from '../../components/FeatureGate'
// // import {FEATURE_KEYS} from '../../features/featureRegistry'
// // import Button from '../../components/Button/Button'
// // import roleContext from '../../context/roleContext'
// // import {setupAxios, useAuth} from '../../modules/auth'
// // import {RoleContextValue} from '../../types/OtherTypes'
// // import CreateUser from './CreateUser'
// // import BulkUserUpload from './components/BulkUserUpload'
// // import {getPartnerUser} from './UserFunction'
// // import {api} from '../../../api/APIMiddlewares'
// // import API from '../../../api/APIUrl'
// // import { getProbationaryUsers, getFullTimeUsers, updateEmploymentStatus, bulkUpdateWorkingShift } from '../../../api/AdminAPI'
// // import { getWorkingShifts } from '../../../api/WorkingShiftAPI'
// // import { differenceInCalendarDays } from 'date-fns'
// // const normalizeEmployment = (employment?: string) => {
// //   if (!employment) return employment
// //   const map: Record<string, string> = {
// //     Employee: 'Full-Time',
// //     employee: 'Full-Time',
// //     'Full Time': 'Full-Time',
// //     FULLTIME: 'Full-Time',
// //   }
// //   return map[employment] || employment
// // }
// // const User = () => {
// //   const [isCreateUserModalOpen, setIsCreateUserModalOpen] = useState(false)
// //   const {currentUser} = useAuth()
// //   const [activeTab, setActiveTab] = useState('Full-Time')
// //   const [manageModal, setManageModal] = useState<{open:boolean; user:any|null}>({open:false, user:null})
// //   const location = useLocation()
// //   const [search, setSearch] = useState('')

// //   // Multi-select state for bulk operations
// //   const [selectedUsers, setSelectedUsers] = useState<Set<string>>(new Set())
// //   const [selectAllOnPage, setSelectAllOnPage] = useState(false)

// //   // Working shift modal state
// //   const [workingShiftModal, setWorkingShiftModal] = useState(false)
// //   const [workingShifts, setWorkingShifts] = useState<{id: string; shiftName: string; startTime: string; endTime: string}[]>([])
// //   const [selectedShiftId, setSelectedShiftId] = useState<string | null>(null)
// //   const [bulkUpdateLoading, setBulkUpdateLoading] = useState(false)
// //   const handleTabClick = (tab) => {
// //     if (tab === activeTab) return
// //     setActiveTab(tab)
// //     setActivePage(1)
// //     setSearch('')
// //     // Clear selections when switching tabs
// //     setSelectedUsers(new Set())
// //     setSelectAllOnPage(false)
// //   }

// //   // Toggle individual user selection
// //   const toggleUserSelection = (userId: string) => {
// //     setSelectedUsers((prev) => {
// //       const newSet = new Set(prev)
// //       if (newSet.has(userId)) {
// //         newSet.delete(userId)
// //       } else {
// //         newSet.add(userId)
// //       }
// //       return newSet
// //     })
// //   }

// //   // Toggle select all on current page
// //   const toggleSelectAllOnPage = () => {
// //     if (selectAllOnPage) {
// //       // Deselect all on current page
// //       const currentPageIds = new Set(displayItems.map((u: any) => u.id))
// //       setSelectedUsers((prev) => {
// //         const newSet = new Set(prev)
// //         currentPageIds.forEach((id) => newSet.delete(id))
// //         return newSet
// //       })
// //       setSelectAllOnPage(false)
// //     } else {
// //       // Select all on current page
// //       const currentPageIds = displayItems.map((u: any) => u.id)
// //       setSelectedUsers((prev) => {
// //         const newSet = new Set(prev)
// //         currentPageIds.forEach((id) => newSet.add(id))
// //         return newSet
// //       })
// //       setSelectAllOnPage(true)
// //     }
// //   }

// //   // Open working shift modal
// //   const openWorkingShiftModal = async () => {
// //     try {
// //       const res = await getWorkingShifts(true)
// //       if (res.statusCode === 200) {
// //         setWorkingShifts(res.data || [])
// //       } else {
// //         setWorkingShifts([])
// //       }
// //     } catch (error) {
// //       console.error('Error fetching working shifts:', error)
// //       setWorkingShifts([])
// //     }
// //     setWorkingShiftModal(true)
// //     setSelectedShiftId(null)
// //   }

// //   // Handle bulk working shift update
// //   const handleBulkWorkingShiftUpdate = async () => {
// //     if (!selectedShiftId || selectedUsers.size === 0) {
// //       Message('Please select a working shift and at least one user', 'error')
// //       return
// //     }

// //     setBulkUpdateLoading(true)
// //     try {
// //       const userIds = Array.from(selectedUsers)
// //       const res = await bulkUpdateWorkingShift(userIds, selectedShiftId)

// //       if (res.statusCode === 200) {
// //         Message(res.message || `Successfully updated working shift for ${userIds.length} user(s)`, 'success')
// //         setWorkingShiftModal(false)
// //         setSelectedUsers(new Set())
// //         setSelectAllOnPage(false)
// //         setSelectedShiftId(null)
// //         fetchUsers()
// //       } else {
// //         Message(res.message || 'Failed to update working shifts', 'error')
// //       }
// //     } catch (error: any) {
// //       console.error('Error updating working shifts:', error)
// //       Message(error?.message || 'Failed to update working shifts', 'error')
// //     } finally {
// //       setBulkUpdateLoading(false)
// //     }
// //   }
// //   const [activePage, setActivePage] = useState(1)
// //   const [rowsPerPage, setRowsPerPage] = useState<number>(() => {
// //     const saved = sessionStorage.getItem('users_rows_per_page')
// //     const parsed = saved ? parseInt(saved) : 10
// //     return [10, 25, 50, 100].includes(parsed) ? parsed : 10
// //   })
// //   const [sortBy, setSortBy] = useState<string>('createdAt')
// //   const [sortDir, setSortDir] = useState<'asc' | 'desc'>('desc')
// //   const serverSortableKeys = useMemo(() => new Set(['firstName', 'lastName', 'email', 'mobile', 'createdAt', 'joiningDate', 'status']), [])
// //   const clientSortableKeys = useMemo(() => new Set(['designation', 'employment', 'role']), [])
// //   const cycleSort = (key: string) => {
// //     if (sortBy !== key) {
// //       setSortBy(key)
// //       setSortDir('asc')
// //       setActivePage(1)
// //       return
// //     }
// //     if (sortDir === 'asc') {
// //       setSortDir('desc')
// //       setActivePage(1)
// //       return
// //     }
// //     // Reset to default (no sort on this column)
// //     setSortBy('createdAt')
// //     setSortDir('desc')
// //     setActivePage(1)
// //   }
// //   let roleState: RoleContextValue = useContext(roleContext)

// //   // Check if user can perform bulk operations (Admin, Super Admin, HR, RM)
// //   const canBulkUpdate = useMemo(() => {
// //     return currentUser?.isAdmin === true || 
// //            currentUser?.isRmOrHr === true ||
// //            checkRole(['Users Registration', 'Roles', 'General Config'], roleState.features)
// //   }, [currentUser, roleState.features])

// //   const [user, setUser] = useState<{
// //     items: {
// //       id: string
// //       firstName: string
// //       lastName: string
// //       email: string
// //       mobile: string
// //       password: string
// //       dob: string
// //       gender: string
// //       employment: string
// //       employmentStatus?: string
// //       designation: string
// //       startDate: string
// //       endDate: string
// //       joiningDate?: string
// //       probationEndDate?: string
// //       userRoles: string[]
// //       inTime: string
// //       outTime: string
// //       reportingManager: {
// //         firstName: string
// //         lastName: string
// //       }
// //       hrManager: {
// //         firstName: string
// //         lastName: string
// //       }
// //       associates: {
// //         associateType: string
// //         userAssociate: {id: string; firstName: string; lastName: string}
// //       }[]
// //       personalEmail: string
// //       salaryStrucutre: string
// //     }[]

// //     limit: number
// //     page: number
// //     total: number
// //   }>({items: [], limit: 10, page: 1, total: 0})
// //   const [APIStatus, setAPIStatus] = useState({
// //     loading: false,
// //     error: null,
// //   })
// //   const [isBulkUploadOpen, setIsBulkUploadOpen] = useState(false)
// //   // Debounced live search (reset to page 1)
// //   useEffect(() => {
// //     if (!search) return
// //     const handler = setTimeout(() => {
// //       setActivePage(1)
// //       fetchUsers()
// //     }, 400)
// //     return () => clearTimeout(handler)
// //     // eslint-disable-next-line react-hooks/exhaustive-deps
// //   }, [search])

// //   // Sync tab from query param (?tab=Probationary|Full-Time)
// //   useEffect(() => {
// //     const params = new URLSearchParams(location.search)
// //     const tab = params.get('tab')
// //     if (tab && ['Active','Inactive','Probationary','Full-Time'].includes(tab)) {
// //       setActiveTab(tab)
// //     }
// //     // eslint-disable-next-line react-hooks/exhaustive-deps
// //   }, [])
// //   const getUser = (setUser: Function, setAPIStatus: Function, page: number, status: string) => {
// //     let {token, tenantId} = setupAxios()
// //     setAPIStatus((prev: any) => ({...prev, loading: true}))
// //     const baseUrl = `/${API.USER}?preset=full&page=${page}&limit=${rowsPerPage}&status=${status}`
// //     const searchParam = search ? `&search=${encodeURIComponent(search)}` : ''
// //     const sortParams = serverSortableKeys.has(sortBy)
// //       ? `&sortBy=${encodeURIComponent(sortBy)}&sort=${encodeURIComponent(sortDir)}`
// //       : ''

// //     api
// //       .get(
// //         `${baseUrl}${searchParam}${sortParams}`,
// //         token,
// //         tenantId,
// //         false
// //       )
// //       .then((res) => {
// //         if (res.statusCode === 200) {
// //           setUser(res?.data)
// //           setAPIStatus((prev: any) => ({...prev, loading: false, error: null}))
// //         } else {
// //           setUser({items: [], limit: 10, page: 1, total: 0})
// //           setAPIStatus((prev: any) => ({...prev, loading: false, error: res.message}))
// //         }
// //       })
// //       .catch((error) => {
// //         // Handle error silently or use proper error handling
// //       })
// //   }
// //   const fetchUsers = () => {
// //     const statusParam = activeTab === 'Full-Time' ? 'Full-Time' : activeTab === 'Probationary' ? 'Probationary' : activeTab
// //     return getUser(setUser, setAPIStatus, activePage, statusParam)
// //   }
// //   const displayItems = useMemo(() => {
// //     const items = user?.items || []
// //     if (!clientSortableKeys.has(sortBy)) return items
// //     const dir = sortDir === 'asc' ? 1 : -1
// //     const getVal = (obj: any): string => {
// //       if (sortBy === 'designation') return (obj?.designation || '').toString()
// //       if (sortBy === 'employment')return (obj?.employment || '').toString()

// //       if (sortBy === 'role') return (obj?.userRoles || []).join(',')
// //       return ''
// //     }
// //     return [...items].sort((a, b) => getVal(a).localeCompare(getVal(b)) * dir)
// //   }, [user?.items, sortBy, sortDir, clientSortableKeys, activeTab])
// //   // Refetch on tab/page/rows/sort change (server-side pagination)
// //   useEffect(() => {
// //     fetchUsers()
// //     // eslint-disable-next-line react-hooks/exhaustive-deps
// //   }, [activeTab, activePage, rowsPerPage, sortBy, sortDir])

// //   // Update selectAllOnPage state when displayItems or selectedUsers changes
// //   useEffect(() => {
// //     if (displayItems.length === 0) {
// //       setSelectAllOnPage(false)
// //       return
// //     }
// //     const allOnPageSelected = displayItems.every((u: any) => selectedUsers.has(u.id))
// //     setSelectAllOnPage(allOnPageSelected)
// //   }, [displayItems, selectedUsers])

// //   return (
// //     <>
// //       {' '}
// //       <div>
// //         <div
// //           // id='kt_toolbar_container'
// //           className={clsx('d-flex justify-content-between align-items-center mb-4')}
// //         >
// //           <div className='d-flex h-55px'>
// //             <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap'>
// //               <FeatureGate feature={FEATURE_KEYS.users_active_list}>
// //                 <li className='nav-item'>
// //                   <Link
// //                     className={clsx('nav-link text-active-primary me-4', {
// //                       active: activeTab === 'Active',
// //                     })}
// //                     to=''
// //                     onClick={() => handleTabClick('Active')}
// //                   >
// //                     Active
// //                   </Link>
// //                 </li>
// //               </FeatureGate>

// //               <FeatureGate feature={FEATURE_KEYS.users_inactive_list}>
// //                 <li className='nav-item'>
// //                   <Link
// //                     className={clsx('nav-link text-active-primary me-4', {
// //                       active: activeTab === 'Inactive',
// //                     })}
// //                     to=''
// //                     onClick={() => handleTabClick('Inactive')}
// //                   >
// //                     Inactive
// //                   </Link>
// //                 </li>
// //               </FeatureGate>

// //               {currentUser?.isRmOrHr && (
// //                 <>
// //                   <li className='nav-item'>
// //                     <Link
// //                       className={clsx('nav-link text-active-primary me-4', {
// //                         active: activeTab === 'Full-Time',
// //                       })}
// //                       to=''
// //                       onClick={() => handleTabClick('Full-Time')}
// //                     >
// //                       Full-Time
// //                     </Link>
// //                   </li>
// //                   <li className='nav-item'>
// //                     <Link
// //                       className={clsx('nav-link text-active-primary me-4', {
// //                         active: activeTab === 'Probationary',
// //                       })}
// //                       to=''
// //                       onClick={() => handleTabClick('Probationary')}
// //                     >
// //                       Probationary
// //                     </Link>
// //                   </li>
// //                 </>
// //               )}
// //             </ul>
// //           </div>
// //           <div className='d-flex align-items-center me-5'>
// //             <input
// //               type='text'
// //               className='form-control form-control-sm'
// //               placeholder='Search users...'
// //               value={search}
// //               onChange={(e) => setSearch(e.target.value)}
// //               onKeyDown={(e) => {
// //                 if (e.key === 'Enter') {
// //                   setActivePage(1)
// //                   fetchUsers()
// //                 }
// //               }}
// //               style={{width: '260px'}}
// //             />
// //             {/* Search button removed; live search triggers on typing */}
// //           </div>
// //         </div>
// //       </div>
// //       <KTCard>
// //         <div className='card-header'>
// //           <div className='card-title'>{activeTab} Users</div>
// //           <div className='card-toolbar'>
// //             <div className='d-flex justify-content-end align-items-center' data-kt-user-table-toolbar='base'>
// //               {/* Bulk Update Working Shift Button */}
// //               {canBulkUpdate && selectedUsers.size > 0 && (
// //                 <Button
// //                   variant='warning'
// //                   size='sm'
// //                   leftIcon={<i className='fas fa-clock'></i>}
// //                   onClick={openWorkingShiftModal}
// //                   className='me-2'
// //                 >
// //                   Update Shift ({selectedUsers.size} selected)
// //                 </Button>
// //               )}
// //               {canBulkUpdate && selectedUsers.size > 0 && (
// //                 <Button
// //                   variant='light'
// //                   size='sm'
// //                   onClick={() => {
// //                     setSelectedUsers(new Set())
// //                     setSelectAllOnPage(false)
// //                   }}
// //                   className='me-2'
// //                 >
// //                   Clear Selection
// //                 </Button>
// //               )}
// //               <FeatureGate feature={FEATURE_KEYS.users_list}>
// //                 <Button
// //                   variant='secondary'
// //                   size='sm'
// //                   leftIcon={<i className='fas fa-file-upload'></i>}
// //                   hidden={activeTab === 'Inactive'}
// //                   onClick={() => setIsBulkUploadOpen(true)}
// //                   className='me-2'
// //                 >
// //                   Upload Users (Excel/CSV)
// //                 </Button>
// //                 <Button
// //                   variant='primary'
// //                   size='sm'
// //                   leftIcon={<i className='fas fa-plus'></i>}
// //                   hidden={activeTab === 'Inactive'}
// //                   onClick={() => {
// //                     setIsCreateUserModalOpen(true)
// //                   }}
// //                 >
// //                   Add User
// //                 </Button>
// //               </FeatureGate>
// //             </div>
// //           </div>
// //         </div>
// //         <KTCardBody className='py-4'>
// //           <div className='table-responsive'>
// //             {APIStatus.loading ? (
// //               <Center>
// //                 {/* Render your loading spinner or indicator here */}
// //                 <Loader />
// //               </Center>
// //             ) : (
// //               <table
// //                 id='kt_table_users'
// //                 className='table align-middle table-row-dashed fs-6 dataTable'
// //               >
// //                 <thead className=' text-muted fw-bolder fs-7 text-uppercase gs-0 text-start'>
// //                   <tr>
// //                     {canBulkUpdate && (
// //                       <th style={{width: '50px'}}>
// //                         <Checkbox
// //                           checked={selectAllOnPage && displayItems.length > 0}
// //                           indeterminate={selectedUsers.size > 0 && !selectAllOnPage}
// //                           onChange={toggleSelectAllOnPage}
// //                           title='Select all on this page'
// //                         />
// //                       </th>
// //                     )}
// //                     <th></th>
// //                     <th role='button' title='Click to sort' onClick={() => cycleSort('firstName')}>
// //                       Name {sortBy === 'firstName' ? (sortDir === 'asc' ? '↑' : '↓') : ''}
// //                     </th>
// //                     <th role='button' title='Click to sort' onClick={() => cycleSort('mobile')}>
// //                       Contact {sortBy === 'mobile' ? (sortDir === 'asc' ? '↑' : '↓') : ''}
// //                     </th>
// //                     <th role='button' title='Click to sort' onClick={() => cycleSort('designation')}>
// //                       Designation {sortBy === 'designation' ? (sortDir === 'asc' ? '↑' : '↓') : ''}
// //                     </th>
// //                     <th role='button' title='Click to sort' onClick={() => cycleSort('employment')}>
// //                       Employment Type {sortBy === 'employment' ? (sortDir === 'asc' ? '↑' : '↓') : ''}
// //                     </th>
// //                     <th role='button' title='Click to sort' onClick={() => cycleSort('role')}>
// //                       Role {sortBy === 'role' ? (sortDir === 'asc' ? '↑' : '↓') : ''}
// //                     </th>
// //                     {activeTab === 'Probationary' ? (
// //                       <th>Probation Ends</th>
// //                     ) : (
// //                       <>
// //                         <th>Reporting Manager</th>
// //                         <th>Human Resource</th>
// //                       </>
// //                     )}
// //                     <th>Actions</th>
// //                   </tr>
// //                 </thead>
// //                 {displayItems?.length > 0 ? (
// //                   <tbody className='text-gray-800 fw-semibold text-left'>
// //                     {displayItems?.map((obj) => {
// //                       return (
// //                         <tr key={obj?.id}>
// //                           {canBulkUpdate && (
// //                             <td>
// //                               <Checkbox
// //                                 checked={selectedUsers.has(obj?.id)}
// //                                 onChange={() => toggleUserSelection(obj?.id)}
// //                               />
// //                             </td>
// //                           )}
// //                           <td className='symbol symbol-45px'>
// //                             <img
// //                               src={toAbsoluteUrl('/media/avatars/blank.png')}
// //                               alt='user profile'
// //                             />
// //                           </td>
// //                           <td style={{minWidth: '70px', paddingLeft: '10px'}}>
// //                             {changeTextCamal(obj?.firstName)} {changeTextCamal(obj?.lastName)}{' '}
// //                             <br />
// //                             <a
// //                               className='fs-7'
// //                               href={`mailto:${obj?.email}`}
// //                               target='_blank'
// //                               rel='noopener noreferrer'
// //                             >
// //                               {obj?.email}
// //                             </a>
// //                           </td>

// //                           <td>{`${obj?.mobile ? '+91' + obj.mobile : '-'}`}</td>

// //                           <td>{changeTextCamal(obj?.designation)}</td>
// //                           <td>{changeTextCamal(normalizeEmployment(obj?.employment))}</td>
// //                           <td>{obj?.userRoles?.map((item) => item)}</td>
// //                           {activeTab === 'Probationary' ? (
// //                             <td>
// //                               {(() => {
// //                                 const now = new Date();
// //                                 const jd = obj.joiningDate ? new Date(obj.joiningDate) : null as any;
// //                                 let pe = obj.probationEndDate ? new Date(obj.probationEndDate) : null as any;
// //                                 if (!pe && jd) {
// //                                   const d = new Date(jd);
// //                                   d.setMonth(d.getMonth() + 6);
// //                                   pe = d;
// //                                 }
// //                                 if (!pe) return '-';
// //                                 const days = Math.ceil((pe.getTime() - now.getTime()) / (1000 * 60 * 60 * 24));
// //                                 if (days <= 30 && days >= 0) {
// //                                   return (
// //                                     <span className='badge badge-light-warning'>
// //                                       {pe.toLocaleDateString()} ({days} days)
// //                                     </span>
// //                                   );
// //                                 }
// //                                 return '-';
// //                               })()}
// //                             </td>
// //                           ) : (
// //                             <>
// //                               <td style={{minWidth: '70px', paddingLeft: '10px'}}>
// //                                 {obj.associates.some((item) => item.associateType === 'RM') ? (
// //                                   <span>
// //                                     {obj.associates?.map((associate) =>
// //                                       associate.associateType === 'RM' ? (
// //                                         <>
// //                                           {changeTextCamal(associate?.userAssociate?.firstName)}{' '}
// //                                           {changeTextCamal(associate?.userAssociate?.lastName)}
// //                                         </>
// //                                       ) : (
// //                                         ''
// //                                       )
// //                                     )}
// //                                   </span>
// //                                 ) : (
// //                                   '-'
// //                                 )}
// //                               </td>
// //                               <td>
// //                                 {obj.associates.some((item) => item.associateType === 'HR') ? (
// //                                   <span>
// //                                     {obj.associates?.map((associate) =>
// //                                       associate.associateType === 'HR' ? (
// //                                         <>
// //                                           {changeTextCamal(associate?.userAssociate?.firstName)}{' '}
// //                                           {changeTextCamal(associate?.userAssociate?.lastName)}
// //                                         </>
// //                                       ) : (
// //                                         ''
// //                                       )
// //                                     )}
// //                                   </span>
// //                                 ) : (
// //                                   '-'
// //                                 )}
// //                               </td>
// //                             </>
// //                           )}

// //                           {/* Actions */}
// //                           <td>
// //                             <div className='d-flex justify-content-center flex-shrink-0'>
// //                               {/* Existing actions */}
// //                               <Link
// //                                 className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
// //                                 to={`/profile/${obj?.id}`}
// //                               >
// //                                 <i className='fas fa-eye'></i>
// //                               </Link>

// //                               {/* HR/Admin probation manage modal trigger */}
// //                               {['Probationary'].includes(activeTab) && (
// //                                 (obj.associates?.some((a:any)=> a.associateType==='HR' && currentUser?.id && a.userAssociate && a.userAssociate.id === currentUser.id)) ||
// //                                 (currentUser?.isAdmin === true) ||
// //                                 (checkRole(['Users Registration','Roles','General Config'], roleState.features))
// //                               ) && (
// //                                 <>
// //                                   {typeof (obj as any).remainingDays === 'number' && (obj as any).remainingDays <= 30 && (
// //                                     <span className='badge badge-light-warning me-2'>
// //                                       {(obj as any).remainingDays} days left
// //                                     </span>
// //                                   )}
// //                                   <button className='btn btn-sm btn-primary' onClick={()=> setManageModal({open:true, user: obj})}>
// //                                     Manage
// //                                   </button>
// //                                 </>
// //                               )}
// //                             </div>
// //                           </td>
// //                         </tr>
// //                       )
// //                     })}
// //                   </tbody>
// //                 ) : (
// //                   <tbody>
// //                     <tr>
// //                       <td colSpan={canBulkUpdate ? 10 : 9}>
// //                         <Center>
// //                           <Text>No users found</Text>
// //                         </Center>
// //                       </td>
// //                     </tr>
// //                   </tbody>
// //                 )}
// //               </table>
// //             )}
// //           </div>
// //           <div className='d-flex mt-4'>
// //             <Text className='me-auto'>
// //               {getPaginationInfoData(activePage, String(rowsPerPage), user?.total?.toString() ?? '', {
// //                 data: user?.items ?? '',
// //               })}{' '}
// //               Of {Math.ceil(Number(user?.total ?? 0))}
// //             </Text>
// //             <div className='d-flex align-items-center gap-3'>
// //               <div className='d-flex align-items-center'>
// //                 <span className='me-2'>Rows:</span>
// //                 <select
// //                   className='form-select form-select-sm'
// //                   value={rowsPerPage}
// //                   onChange={(e) => {
// //                     const val = parseInt(e.target.value)
// //                     sessionStorage.setItem('users_rows_per_page', String(val))
// //                     setRowsPerPage(val)
// //                     setActivePage(1)
// //                   }}
// //                 >
// //                   {[10,25,50,100].map((n) => (
// //                     <option key={n} value={n}>{n}</option>
// //                   ))}
// //                 </select>
// //               </div>
// //               <Pagination
// //               value={activePage}
// //               size='lg'
// //               styles={(theme) => ({
// //                 control: {
// //                   '&[data-active]': {
// //                     backgroundImage: theme.colorScheme,
// //                   },
// //                 },
// //               })}
// //               onChange={(page) => {
// //                 setActivePage(page)
// //                 // Use properly mapped status instead of raw activeTab
// //                 const statusParam = activeTab === 'Full-Time' ? 'Full-Time' : activeTab === 'Probationary' ? 'Probationary' : activeTab
// //                 getUser(setUser, setAPIStatus, page, statusParam)
// //               }}
// //               total={Math.ceil(Number(user?.total ?? 0) / Number(rowsPerPage))}
// //             ></Pagination>
// //             </div>
// //           </div>
// //         </KTCardBody>
// //       </KTCard>
// //       {isCreateUserModalOpen && (
// //         <CreateUser
// //           closeModal={() => setIsCreateUserModalOpen(false)}
// //           user={user}
// //           setUser={setUser}
// //           fetchUsers={fetchUsers}
// //         />
// //       )}
// //       {isBulkUploadOpen && (
// //         <BulkUserUpload
// //           onClose={() => setIsBulkUploadOpen(false)}
// //           onUploaded={() => {
// //             setIsBulkUploadOpen(false)
// //             fetchUsers()
// //           }}
// //         />
// //       )}
// //       {manageModal.open && (
// //         <div className='modal fade show d-block' tabIndex={-1}>
// //           <div className='modal-dialog'>
// //             <div className='modal-content'>
// //               <div className='modal-header'>
// //                 <h5 className='modal-title'>Manage Probation</h5>
// //                 <button type='button' className='btn-close' onClick={()=> setManageModal({open:false, user:null})}></button>
// //               </div>
// //               <div className='modal-body'>
// //                 <p className='mb-4'>Choose an action for {changeTextCamal(manageModal.user?.firstName)} {changeTextCamal(manageModal.user?.lastName)}</p>
// //                 <div className='d-flex gap-3'>
// //                   <label className='btn btn-light-primary'>
// //                     <i className='fas fa-upload me-1'></i> Convert to Full-Time (upload docs)
// //                     <input type='file' hidden accept='.pdf,.doc,.docx' onChange={async (e)=>{
// //                       const file = e.target.files?.[0]
// //                       if (!file) return
// //                       const res = await updateEmploymentStatus(manageModal.user.id, 'FULL_TIME', file)
// //                       if (res.statusCode === 200) {
// //                         Message('User marked Full-Time','success')
// //                         setManageModal({open:false, user:null})
// //                         fetchUsers()
// //                       } else {
// //                         Message(res.message || 'Failed','error')
// //                       }
// //                       try { if (e.currentTarget) e.currentTarget.value = '' } catch {}
// //                     }}/>
// //                   </label>
// //                   <button className='btn btn-light-danger' onClick={async ()=>{
// //                     const res = await updateEmploymentStatus(manageModal.user.id, 'LAID_OFF')
// //                     if (res.statusCode === 200) {
// //                       Message('User marked Laid-Off','success')
// //                       setManageModal({open:false, user:null})
// //                       fetchUsers()
// //                     } else {
// //                       Message(res.message || 'Failed','error')
// //                     }
// //                   }}>
// //                     <i className='fas fa-user-slash me-1'></i> Lay Off
// //                   </button>
// //                 </div>
// //               </div>
// //               <div className='modal-footer'>
// //                 <button className='btn btn-secondary' onClick={()=> setManageModal({open:false, user:null})}>Close</button>
// //               </div>
// //             </div>
// //           </div>
// //         </div>
// //       )}

// //       {/* Bulk Update Working Shift Modal */}
// //       <Modal
// //         opened={workingShiftModal}
// //         onClose={() => {
// //           setWorkingShiftModal(false)
// //           setSelectedShiftId(null)
// //         }}
// //         title={
// //           <div>
// //             <h5 className='mb-1'>Update Working Shift</h5>
// //             <small className='text-muted'>
// //               {selectedUsers.size} user(s) selected
// //             </small>
// //           </div>
// //         }
// //         size='md'
// //         centered
// //       >
// //         <div className='mb-4'>
// //           <p className='text-muted mb-3'>
// //             Select a working shift to apply to all selected users. This will update their shift timing.
// //           </p>

// //           <Select
// //             label='Working Shift'
// //             placeholder='Select a working shift'
// //             value={selectedShiftId}
// //             onChange={(value) => setSelectedShiftId(value)}
// //             data={workingShifts.map((shift) => ({
// //               value: shift.id,
// //               label: `${shift.shiftName} (${shift.startTime} - ${shift.endTime})`,
// //             }))}
// //             searchable
// //             clearable
// //             nothingFound='No working shifts found'
// //           />

// //           {selectedShiftId && (
// //             <div className='mt-3 p-3 bg-light rounded'>
// //               <small className='text-muted'>Selected shift details:</small>
// //               {(() => {
// //                 const shift = workingShifts.find((s) => s.id === selectedShiftId)
// //                 if (!shift) return null
// //                 return (
// //                   <div className='mt-2'>
// //                     <strong>{shift.shiftName}</strong>
// //                     <br />
// //                     <span className='text-muted'>
// //                       <i className='fas fa-clock me-1'></i>
// //                       {shift.startTime} - {shift.endTime}
// //                     </span>
// //                   </div>
// //                 )
// //               })()}
// //             </div>
// //           )}
// //         </div>

// //         <div className='d-flex justify-content-end gap-2'>
// //           <Button
// //             variant='light'
// //             onClick={() => {
// //               setWorkingShiftModal(false)
// //               setSelectedShiftId(null)
// //             }}
// //           >
// //             Cancel
// //           </Button>
// //           <Button
// //             variant='primary'
// //             onClick={handleBulkWorkingShiftUpdate}
// //             disabled={!selectedShiftId || bulkUpdateLoading}
// //             loading={bulkUpdateLoading}
// //           >
// //             Update {selectedUsers.size} User(s)
// //           </Button>
// //         </div>
// //       </Modal>
// //     </>
// //   )
// // }

// // export default User
// import {Center, clsx, Loader, Pagination, Text, Checkbox, Modal, Select} from '@mantine/core'
// import {useContext, useEffect, useMemo, useState} from 'react'
// import {Link, useLocation} from 'react-router-dom'
// import {
//   KTCard,
//   KTCardBody,
//   Message,
//   changeTextCamal,
//   checkRole,
//   getPaginationInfoData,
//   toAbsoluteUrl,
// } from '../../../_metronic/helpers'
// import FeatureGate from '../../components/FeatureGate'
// import {FEATURE_KEYS} from '../../features/featureRegistry'
// import Button from '../../components/Button/Button'
// import roleContext from '../../context/roleContext'
// import {setupAxios, useAuth} from '../../modules/auth'
// import {RoleContextValue} from '../../types/OtherTypes'
// import CreateUser from './CreateUser'
// import BulkUserUpload from './components/BulkUserUpload'
// import {getPartnerUser} from './UserFunction'
// import {api} from '../../../api/APIMiddlewares'
// import API from '../../../api/APIUrl'
// import { getProbationaryUsers, getFullTimeUsers, updateEmploymentStatus, bulkUpdateWorkingShift } from '../../../api/AdminAPI'
// import { getWorkingShifts } from '../../../api/WorkingShiftAPI'
// import { differenceInCalendarDays } from 'date-fns'

// const User = () => {
//   const [isCreateUserModalOpen, setIsCreateUserModalOpen] = useState(false)
//   const {currentUser} = useAuth()
//   const [activeTab, setActiveTab] = useState('Full-Time')
//   const [manageModal, setManageModal] = useState<{open:boolean; user:any|null}>({open:false, user:null})
//   const location = useLocation()
//   const [search, setSearch] = useState('')

//   // Multi-select state for bulk operations
//   const [selectedUsers, setSelectedUsers] = useState<Set<string>>(new Set())
//   const [selectAllOnPage, setSelectAllOnPage] = useState(false)

//   // Working shift modal state
//   const [workingShiftModal, setWorkingShiftModal] = useState(false)
//   const [workingShifts, setWorkingShifts] = useState<{id: string; shiftName: string; startTime: string; endTime: string}[]>([])
//   const [selectedShiftId, setSelectedShiftId] = useState<string | null>(null)
//   const [bulkUpdateLoading, setBulkUpdateLoading] = useState(false)
//   const handleTabClick = (tab) => {
//     if (tab === activeTab) return
//     setActiveTab(tab)
//     setActivePage(1)
//     setSearch('')
//     // Clear selections when switching tabs
//     setSelectedUsers(new Set())
//     setSelectAllOnPage(false)
//   }

//   // Toggle individual user selection
//   const toggleUserSelection = (userId: string) => {
//     setSelectedUsers((prev) => {
//       const newSet = new Set(prev)
//       if (newSet.has(userId)) {
//         newSet.delete(userId)
//       } else {
//         newSet.add(userId)
//       }
//       return newSet
//     })
//   }

//   // Toggle select all on current page
//   const toggleSelectAllOnPage = () => {
//     if (selectAllOnPage) {
//       // Deselect all on current page
//       const currentPageIds = new Set(displayItems.map((u: any) => u.id))
//       setSelectedUsers((prev) => {
//         const newSet = new Set(prev)
//         currentPageIds.forEach((id) => newSet.delete(id))
//         return newSet
//       })
//       setSelectAllOnPage(false)
//     } else {
//       // Select all on current page
//       const currentPageIds = displayItems.map((u: any) => u.id)
//       setSelectedUsers((prev) => {
//         const newSet = new Set(prev)
//         currentPageIds.forEach((id) => newSet.add(id))
//         return newSet
//       })
//       setSelectAllOnPage(true)
//     }
//   }

//   // Open working shift modal
//   const openWorkingShiftModal = async () => {
//     try {
//       const res = await getWorkingShifts(true)
//       if (res.statusCode === 200) {
//         setWorkingShifts(res.data || [])
//       } else {
//         setWorkingShifts([])
//       }
//     } catch (error) {
//       console.error('Error fetching working shifts:', error)
//       setWorkingShifts([])
//     }
//     setWorkingShiftModal(true)
//     setSelectedShiftId(null)
//   }

//   // Handle bulk working shift update
//   const handleBulkWorkingShiftUpdate = async () => {
//     if (!selectedShiftId || selectedUsers.size === 0) {
//       Message('Please select a working shift and at least one user', 'error')
//       return
//     }

//     setBulkUpdateLoading(true)
//     try {
//       const userIds = Array.from(selectedUsers)
//       const res = await bulkUpdateWorkingShift(userIds, selectedShiftId)

//       if (res.statusCode === 200) {
//         Message(res.message || `Successfully updated working shift for ${userIds.length} user(s)`, 'success')
//         setWorkingShiftModal(false)
//         setSelectedUsers(new Set())
//         setSelectAllOnPage(false)
//         setSelectedShiftId(null)
//         fetchUsers()
//       } else {
//         Message(res.message || 'Failed to update working shifts', 'error')
//       }
//     } catch (error: any) {
//       console.error('Error updating working shifts:', error)
//       Message(error?.message || 'Failed to update working shifts', 'error')
//     } finally {
//       setBulkUpdateLoading(false)
//     }
//   }
//   const [activePage, setActivePage] = useState(1)
//   const [rowsPerPage, setRowsPerPage] = useState<number>(() => {
//     const saved = sessionStorage.getItem('users_rows_per_page')
//     const parsed = saved ? parseInt(saved) : 10
//     return [10, 25, 50, 100].includes(parsed) ? parsed : 10
//   })
//   const [sortBy, setSortBy] = useState<string>('createdAt')
//   const [sortDir, setSortDir] = useState<'asc' | 'desc'>('desc')
//   const serverSortableKeys = useMemo(() => new Set(['firstName', 'lastName', 'email', 'mobile', 'createdAt', 'joiningDate', 'status']), [])
//   const clientSortableKeys = useMemo(() => new Set(['designation', 'employment', 'role']), [])
//   const cycleSort = (key: string) => {
//     if (sortBy !== key) {
//       setSortBy(key)
//       setSortDir('asc')
//       setActivePage(1)
//       return
//     }
//     if (sortDir === 'asc') {
//       setSortDir('desc')
//       setActivePage(1)
//       return
//     }
//     // Reset to default (no sort on this column)
//     setSortBy('createdAt')
//     setSortDir('desc')
//     setActivePage(1)
//   }
//   let roleState: RoleContextValue = useContext(roleContext)

//   // Check if user can perform bulk operations (Admin, Super Admin, HR, RM)
//   const canBulkUpdate = useMemo(() => {
//     return currentUser?.isAdmin === true || 
//            currentUser?.isRmOrHr === true ||
//            checkRole(['Users Registration', 'Roles', 'General Config'], roleState.features)
//   }, [currentUser, roleState.features])

//   const [user, setUser] = useState<{
//     items: {
//       id: string
//       firstName: string
//       lastName: string
//       email: string
//       mobile: string
//       password: string
//       dob: string
//       gender: string
//       employment: string
//       employmentStatus?: string
//       designation: string
//       startDate: string
//       endDate: string
//       joiningDate?: string
//       probationEndDate?: string
//       userRoles: string[]
//       inTime: string
//       outTime: string
//       reportingManager: {
//         firstName: string
//         lastName: string
//       }
//       hrManager: {
//         firstName: string
//         lastName: string
//       }
//       associates: {
//         associateType: string
//         userAssociate: {id: string; firstName: string; lastName: string}
//       }[]
//       personalEmail: string
//       salaryStrucutre: string
//     }[]

//     limit: number
//     page: number
//     total: number
//   }>({items: [], limit: 10, page: 1, total: 0})
//   const [APIStatus, setAPIStatus] = useState({
//     loading: false,
//     error: null,
//   })
//   const [isBulkUploadOpen, setIsBulkUploadOpen] = useState(false)
//   // Debounced live search (reset to page 1)
//   useEffect(() => {
//     if (!search) return
//     const handler = setTimeout(() => {
//       setActivePage(1)
//       fetchUsers()
//     }, 400)
//     return () => clearTimeout(handler)
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [search])

//   // Sync tab from query param (?tab=Probationary|Full-Time)
//   useEffect(() => {
//     const params = new URLSearchParams(location.search)
//     const tab = params.get('tab')
//     if (tab && ['Active','Inactive','Probationary','Full-Time'].includes(tab)) {
//       setActiveTab(tab)
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [])
//   const getUser = (setUser: Function, setAPIStatus: Function, page: number, status: string) => {
//     let {token, tenantId} = setupAxios()
//     setAPIStatus((prev: any) => ({...prev, loading: true}))
//     const baseUrl = `/${API.USER}?preset=full&page=${page}&limit=${rowsPerPage}&status=${status}`
//     const searchParam = search ? `&search=${encodeURIComponent(search)}` : ''
//     const sortParams = serverSortableKeys.has(sortBy)
//       ? `&sortBy=${encodeURIComponent(sortBy)}&sort=${encodeURIComponent(sortDir)}`
//       : ''

//     api
//       .get(
//         `${baseUrl}${searchParam}${sortParams}`,
//         token,
//         tenantId,
//         false
//       )
//       .then((res) => {
//         if (res.statusCode === 200) {
//           setUser(res?.data)
//           setAPIStatus((prev: any) => ({...prev, loading: false, error: null}))
//         } else {
//           setUser({items: [], limit: 10, page: 1, total: 0})
//           setAPIStatus((prev: any) => ({...prev, loading: false, error: res.message}))
//         }
//       })
//       .catch((error) => {
//         // Handle error silently or use proper error handling
//       })
//   }
//   const fetchUsers = () => {
//     const statusParam = activeTab === 'Full-Time' ? 'Full-Time' : activeTab === 'Probationary' ? 'Probationary' : activeTab
//     return getUser(setUser, setAPIStatus, activePage, statusParam)
//   }
//   const displayItems = useMemo(() => {
//     const items = user?.items || []
//     if (!clientSortableKeys.has(sortBy)) return items
//     const dir = sortDir === 'asc' ? 1 : -1
//     const getVal = (obj: any): string => {
//       if (sortBy === 'designation') return (obj?.designation || '').toString()
//       if (sortBy === 'employment') return (obj?.employment || '').toString()
//       if (sortBy === 'role') return (obj?.userRoles || []).join(',')
//       return ''
//     }
//     return [...items].sort((a, b) => getVal(a).localeCompare(getVal(b)) * dir)
//   }, [user?.items, sortBy, sortDir, clientSortableKeys, activeTab])
//   // Refetch on tab/page/rows/sort change (server-side pagination)
//   useEffect(() => {
//     fetchUsers()
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [activeTab, activePage, rowsPerPage, sortBy, sortDir])

//   // Update selectAllOnPage state when displayItems or selectedUsers changes
//   useEffect(() => {
//     if (displayItems.length === 0) {
//       setSelectAllOnPage(false)
//       return
//     }
//     const allOnPageSelected = displayItems.every((u: any) => selectedUsers.has(u.id))
//     setSelectAllOnPage(allOnPageSelected)
//   }, [displayItems, selectedUsers])

//   return (
//     <>
//       {' '}
//       <div>
//         <div
//           // id='kt_toolbar_container'
//           className={clsx('d-flex justify-content-between align-items-center mb-4')}
//         >
//           <div className='d-flex h-55px'>
//             <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap'>
//               <FeatureGate feature={FEATURE_KEYS.users_active_list}>
//                 <li className='nav-item'>
//                   <Link
//                     className={clsx('nav-link text-active-primary me-4', {
//                       active: activeTab === 'Active',
//                     })}
//                     to=''
//                     onClick={() => handleTabClick('Active')}
//                   >
//                     Active
//                   </Link>
//                 </li>
//               </FeatureGate>

//               <FeatureGate feature={FEATURE_KEYS.users_inactive_list}>
//                 <li className='nav-item'>
//                   <Link
//                     className={clsx('nav-link text-active-primary me-4', {
//                       active: activeTab === 'Inactive',
//                     })}
//                     to=''
//                     onClick={() => handleTabClick('Inactive')}
//                   >
//                     Inactive
//                   </Link>
//                 </li>
//               </FeatureGate>

//               {currentUser?.isRmOrHr && (
//                 <>
//                   <li className='nav-item'>
//                     <Link
//                       className={clsx('nav-link text-active-primary me-4', {
//                         active: activeTab === 'Full-Time',
//                       })}
//                       to=''
//                       onClick={() => handleTabClick('Full-Time')}
//                     >
//                       Full-Time
//                     </Link>
//                   </li>
//                   <li className='nav-item'>
//                     <Link
//                       className={clsx('nav-link text-active-primary me-4', {
//                         active: activeTab === 'Probationary',
//                       })}
//                       to=''
//                       onClick={() => handleTabClick('Probationary')}
//                     >
//                       Probationary
//                     </Link>
//                   </li>
//                 </>
//               )}
//             </ul>
//           </div>
//           <div className='d-flex align-items-center me-5'>
//             <input
//               type='text'
//               className='form-control form-control-sm'
//               placeholder='Search users...'
//               value={search}
//               onChange={(e) => setSearch(e.target.value)}
//               onKeyDown={(e) => {
//                 if (e.key === 'Enter') {
//                   setActivePage(1)
//                   fetchUsers()
//                 }
//               }}
//               style={{width: '260px'}}
//             />
//             {/* Search button removed; live search triggers on typing */}
//           </div>
//         </div>
//       </div>
//       <KTCard>
//         <div className='card-header'>
//           <div className='card-title'>{activeTab} Users</div>
//           <div className='card-toolbar'>
//             <div className='d-flex justify-content-end align-items-center' data-kt-user-table-toolbar='base'>
//               {/* Bulk Update Working Shift Button */}
//               {canBulkUpdate && selectedUsers.size > 0 && (
//                 <Button
//                   variant='warning'
//                   size='sm'
//                   leftIcon={<i className='fas fa-clock'></i>}
//                   onClick={openWorkingShiftModal}
//                   className='me-2'
//                 >
//                   Update Shift ({selectedUsers.size} selected)
//                 </Button>
//               )}
//               {canBulkUpdate && selectedUsers.size > 0 && (
//                 <Button
//                   variant='light'
//                   size='sm'
//                   onClick={() => {
//                     setSelectedUsers(new Set())
//                     setSelectAllOnPage(false)
//                   }}
//                   className='me-2'
//                 >
//                   Clear Selection
//                 </Button>
//               )}
//               <FeatureGate feature={FEATURE_KEYS.users_list}>
//                 <Button
//                   variant='secondary'
//                   size='sm'
//                   leftIcon={<i className='fas fa-file-upload'></i>}
//                   hidden={activeTab === 'Inactive'}
//                   onClick={() => setIsBulkUploadOpen(true)}
//                   className='me-2'
//                 >
//                   Upload Users (Excel/CSV)
//                 </Button>
//                 <Button
//                   variant='primary'
//                   size='sm'
//                   leftIcon={<i className='fas fa-plus'></i>}
//                   hidden={activeTab === 'Inactive'}
//                   onClick={() => {
//                     setIsCreateUserModalOpen(true)
//                   }}
//                 >
//                   Add User
//                 </Button>
//               </FeatureGate>
//             </div>
//           </div>
//         </div>
//         <KTCardBody className='py-4'>
//           <div className='table-responsive'>
//             {APIStatus.loading ? (
//               <Center>
//                 {/* Render your loading spinner or indicator here */}
//                 <Loader />
//               </Center>
//             ) : (
//               <table
//                 id='kt_table_users'
//                 className='table align-middle table-row-dashed fs-6 dataTable'
//               >
//                 <thead className=' text-muted fw-bolder fs-7 text-uppercase gs-0 text-start'>
//                   <tr>
//                     {canBulkUpdate && (
//                       <th style={{width: '50px'}}>
//                         <Checkbox
//                           checked={selectAllOnPage && displayItems.length > 0}
//                           indeterminate={selectedUsers.size > 0 && !selectAllOnPage}
//                           onChange={toggleSelectAllOnPage}
//                           title='Select all on this page'
//                         />
//                       </th>
//                     )}
//                     <th></th>
//                     <th role='button' title='Click to sort' onClick={() => cycleSort('firstName')}>
//                       Name {sortBy === 'firstName' ? (sortDir === 'asc' ? '↑' : '↓') : ''}
//                     </th>
//                     <th role='button' title='Click to sort' onClick={() => cycleSort('mobile')}>
//                       Contact {sortBy === 'mobile' ? (sortDir === 'asc' ? '↑' : '↓') : ''}
//                     </th>
//                     <th role='button' title='Click to sort' onClick={() => cycleSort('designation')}>
//                       Designation {sortBy === 'designation' ? (sortDir === 'asc' ? '↑' : '↓') : ''}
//                     </th>
//                     <th role='button' title='Click to sort' onClick={() => cycleSort('employment')}>
//                       Employment Type {sortBy === 'employment' ? (sortDir === 'asc' ? '↑' : '↓') : ''}
//                     </th>
//                     <th role='button' title='Click to sort' onClick={() => cycleSort('role')}>
//                       Role {sortBy === 'role' ? (sortDir === 'asc' ? '↑' : '↓') : ''}
//                     </th>
//                     {activeTab === 'Probationary' ? (
//                       <th>Probation Ends</th>
//                     ) : (
//                       <>
//                         <th>Reporting Manager</th>
//                         <th>Human Resource</th>
//                       </>
//                     )}
//                     <th>Actions</th>
//                   </tr>
//                 </thead>
//                 {displayItems?.length > 0 ? (
//                   <tbody className='text-gray-800 fw-semibold text-left'>
//                     {displayItems?.map((obj) => {
//                       return (
//                         <tr key={obj?.id}>
//                           {canBulkUpdate && (
//                             <td>
//                               <Checkbox
//                                 checked={selectedUsers.has(obj?.id)}
//                                 onChange={() => toggleUserSelection(obj?.id)}
//                               />
//                             </td>
//                           )}
//                           <td className='symbol symbol-45px'>
//                             <img
//                               src={toAbsoluteUrl('/media/avatars/blank.png')}
//                               alt='user profile'
//                             />
//                           </td>
//                           <td style={{minWidth: '70px', paddingLeft: '10px'}}>
//                             {changeTextCamal(obj?.firstName)} {changeTextCamal(obj?.lastName)}{' '}
//                             <br />
//                             <a
//                               className='fs-7'
//                               href={`mailto:${obj?.email}`}
//                               target='_blank'
//                               rel='noopener noreferrer'
//                             >
//                               {obj?.email}
//                             </a>
//                           </td>

//                           <td>{`${obj?.mobile ? '+91' + obj.mobile : '-'}`}</td>

//                           <td>{changeTextCamal(obj?.designation)}</td>
//                           <td>{changeTextCamal(obj?.employment)}</td>
//                           <td>{obj?.userRoles?.map((item) => item)}</td>
//                           {activeTab === 'Probationary' ? (
//                             <td>
//                               {(() => {
//                                 const now = new Date();
//                                 const jd = obj.joiningDate ? new Date(obj.joiningDate) : null as any;
//                                 let pe = obj.probationEndDate ? new Date(obj.probationEndDate) : null as any;
//                                 if (!pe && jd) {
//                                   const d = new Date(jd);
//                                   d.setMonth(d.getMonth() + 6);
//                                   pe = d;
//                                 }
//                                 if (!pe) return '-';
//                                 const days = Math.ceil((pe.getTime() - now.getTime()) / (1000 * 60 * 60 * 24));
//                                 if (days <= 30 && days >= 0) {
//                                   return (
//                                     <span className='badge badge-light-warning'>
//                                       {pe.toLocaleDateString()} ({days} days)
//                                     </span>
//                                   );
//                                 }
//                                 return '-';
//                               })()}
//                             </td>
//                           ) : (
//                             <>
//                               <td style={{minWidth: '70px', paddingLeft: '10px'}}>
//                                 {obj.associates.some((item) => item.associateType === 'RM') ? (
//                                   <span>
//                                     {obj.associates?.map((associate) =>
//                                       associate.associateType === 'RM' ? (
//                                         <>
//                                           {changeTextCamal(associate?.userAssociate?.firstName)}{' '}
//                                           {changeTextCamal(associate?.userAssociate?.lastName)}
//                                         </>
//                                       ) : (
//                                         ''
//                                       )
//                                     )}
//                                   </span>
//                                 ) : (
//                                   '-'
//                                 )}
//                               </td>
//                               <td>
//                                 {obj.associates.some((item) => item.associateType === 'HR') ? (
//                                   <span>
//                                     {obj.associates?.map((associate) =>
//                                       associate.associateType === 'HR' ? (
//                                         <>
//                                           {changeTextCamal(associate?.userAssociate?.firstName)}{' '}
//                                           {changeTextCamal(associate?.userAssociate?.lastName)}
//                                         </>
//                                       ) : (
//                                         ''
//                                       )
//                                     )}
//                                   </span>
//                                 ) : (
//                                   '-'
//                                 )}
//                               </td>
//                             </>
//                           )}

//                           {/* Actions */}
//                           <td>
//                             <div className='d-flex justify-content-center flex-shrink-0'>
//                               {/* Existing actions */}
//                               <Link
//                                 className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
//                                 to={`/profile/${obj?.id}`}
//                               >
//                                 <i className='fas fa-eye'></i>
//                               </Link>

//                               {/* HR/Admin probation manage modal trigger */}
//                               {['Probationary'].includes(activeTab) && (
//                                 (obj.associates?.some((a:any)=> a.associateType==='HR' && currentUser?.id && a.userAssociate && a.userAssociate.id === currentUser.id)) ||
//                                 (currentUser?.isAdmin === true) ||
//                                 (checkRole(['Users Registration','Roles','General Config'], roleState.features))
//                               ) && (
//                                 <>
//                                   {typeof (obj as any).remainingDays === 'number' && (obj as any).remainingDays <= 30 && (
//                                     <span className='badge badge-light-warning me-2'>
//                                       {(obj as any).remainingDays} days left
//                                     </span>
//                                   )}
//                                   <button className='btn btn-sm btn-primary' onClick={()=> setManageModal({open:true, user: obj})}>
//                                     Manage
//                                   </button>
//                                 </>
//                               )}
//                             </div>
//                           </td>
//                         </tr>
//                       )
//                     })}
//                   </tbody>
//                 ) : (
//                   <tbody>
//                     <tr>
//                       <td colSpan={canBulkUpdate ? 10 : 9}>
//                         <Center>
//                           <Text>No users found</Text>
//                         </Center>
//                       </td>
//                     </tr>
//                   </tbody>
//                 )}
//               </table>
//             )}
//           </div>
//           <div className='d-flex mt-4'>
//             <Text className='me-auto'>
//               {getPaginationInfoData(activePage, String(rowsPerPage), user?.total?.toString() ?? '', {
//                 data: user?.items ?? '',
//               })}{' '}
//               Of {Math.ceil(Number(user?.total ?? 0))}
//             </Text>
//             <div className='d-flex align-items-center gap-3'>
//               <div className='d-flex align-items-center'>
//                 <span className='me-2'>Rows:</span>
//                 <select
//                   className='form-select form-select-sm'
//                   value={rowsPerPage}
//                   onChange={(e) => {
//                     const val = parseInt(e.target.value)
//                     sessionStorage.setItem('users_rows_per_page', String(val))
//                     setRowsPerPage(val)
//                     setActivePage(1)
//                   }}
//                 >
//                   {[10,25,50,100].map((n) => (
//                     <option key={n} value={n}>{n}</option>
//                   ))}
//                 </select>
//               </div>
//               <Pagination
//               value={activePage}
//               size='lg'
//               styles={(theme) => ({
//                 control: {
//                   '&[data-active]': {
//                     backgroundImage: theme.colorScheme,
//                   },
//                 },
//               })}
//               onChange={(page) => {
//                 setActivePage(page)
//                 // Use properly mapped status instead of raw activeTab
//                 const statusParam = activeTab === 'Full-Time' ? 'Full-Time' : activeTab === 'Probationary' ? 'Probationary' : activeTab
//                 getUser(setUser, setAPIStatus, page, statusParam)
//               }}
//               total={Math.ceil(Number(user?.total ?? 0) / Number(rowsPerPage))}
//             ></Pagination>
//             </div>
//           </div>
//         </KTCardBody>
//       </KTCard>
//       {isCreateUserModalOpen && (
//         <CreateUser
//           closeModal={() => setIsCreateUserModalOpen(false)}
//           user={user}
//           setUser={setUser}
//           fetchUsers={fetchUsers}
//         />
//       )}
//       {isBulkUploadOpen && (
//         <BulkUserUpload
//           onClose={() => setIsBulkUploadOpen(false)}
//           onUploaded={() => {
//             setIsBulkUploadOpen(false)
//             fetchUsers()
//           }}
//         />
//       )}
//       {manageModal.open && (
//         <div className='modal fade show d-block' tabIndex={-1}>
//           <div className='modal-dialog'>
//             <div className='modal-content'>
//               <div className='modal-header'>
//                 <h5 className='modal-title'>Manage Probation</h5>
//                 <button type='button' className='btn-close' onClick={()=> setManageModal({open:false, user:null})}></button>
//               </div>
//               <div className='modal-body'>
//                 <p className='mb-4'>Choose an action for {changeTextCamal(manageModal.user?.firstName)} {changeTextCamal(manageModal.user?.lastName)}</p>
//                 <div className='d-flex gap-3'>
//                   <label className='btn btn-light-primary'>
//                     <i className='fas fa-upload me-1'></i> Convert to Full-Time (upload docs)
//                     <input type='file' hidden accept='.pdf,.doc,.docx' onChange={async (e)=>{
//                       const file = e.target.files?.[0]
//                       if (!file) return
//                       const res = await updateEmploymentStatus(manageModal.user.id, 'FULL_TIME', file)
//                       if (res.statusCode === 200) {
//                         Message('User marked Full-Time','success')
//                         setManageModal({open:false, user:null})
//                         fetchUsers()
//                       } else {
//                         Message(res.message || 'Failed','error')
//                       }
//                       try { if (e.currentTarget) e.currentTarget.value = '' } catch {}
//                     }}/>
//                   </label>
//                   <button className='btn btn-light-danger' onClick={async ()=>{
//                     const res = await updateEmploymentStatus(manageModal.user.id, 'LAID_OFF')
//                     if (res.statusCode === 200) {
//                       Message('User marked Laid-Off','success')
//                       setManageModal({open:false, user:null})
//                       fetchUsers()
//                     } else {
//                       Message(res.message || 'Failed','error')
//                     }
//                   }}>
//                     <i className='fas fa-user-slash me-1'></i> Lay Off
//                   </button>
//                 </div>
//               </div>
//               <div className='modal-footer'>
//                 <button className='btn btn-secondary' onClick={()=> setManageModal({open:false, user:null})}>Close</button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Bulk Update Working Shift Modal */}
//       <Modal
//         opened={workingShiftModal}
//         onClose={() => {
//           setWorkingShiftModal(false)
//           setSelectedShiftId(null)
//         }}
//         title={
//           <div>
//             <h5 className='mb-1'>Update Working Shift</h5>
//             <small className='text-muted'>
//               {selectedUsers.size} user(s) selected
//             </small>
//           </div>
//         }
//         size='md'
//         centered
//       >
//         <div className='mb-4'>
//           <p className='text-muted mb-3'>
//             Select a working shift to apply to all selected users. This will update their shift timing.
//           </p>

//           <Select
//             label='Working Shift'
//             placeholder='Select a working shift'
//             value={selectedShiftId}
//             onChange={(value) => setSelectedShiftId(value)}
//             data={workingShifts.map((shift) => ({
//               value: shift.id,
//               label: `${shift.shiftName} (${shift.startTime} - ${shift.endTime})`,
//             }))}
//             searchable
//             clearable
//             nothingFound='No working shifts found'
//           />

//           {selectedShiftId && (
//             <div className='mt-3 p-3 bg-light rounded'>
//               <small className='text-muted'>Selected shift details:</small>
//               {(() => {
//                 const shift = workingShifts.find((s) => s.id === selectedShiftId)
//                 if (!shift) return null
//                 return (
//                   <div className='mt-2'>
//                     <strong>{shift.shiftName}</strong>
//                     <br />
//                     <span className='text-muted'>
//                       <i className='fas fa-clock me-1'></i>
//                       {shift.startTime} - {shift.endTime}
//                     </span>
//                   </div>
//                 )
//               })()}
//             </div>
//           )}
//         </div>

//         <div className='d-flex justify-content-end gap-2'>
//           <Button
//             variant='light'
//             onClick={() => {
//               setWorkingShiftModal(false)
//               setSelectedShiftId(null)
//             }}
//           >
//             Cancel
//           </Button>
//           <Button
//             variant='primary'
//             onClick={handleBulkWorkingShiftUpdate}
//             disabled={!selectedShiftId || bulkUpdateLoading}
//             loading={bulkUpdateLoading}
//           >
//             Update {selectedUsers.size} User(s)
//           </Button>
//         </div>
//       </Modal>
//     </>
//   )
// }

// export default User
import { Center, clsx, Loader, Pagination, Text, Checkbox, Modal, Select } from '@mantine/core'
import { useContext, useEffect, useMemo, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import {
  KTCard,
  KTCardBody,
  Message,
  changeTextCamal,
  checkRole,
  getPaginationInfoData,
  toAbsoluteUrl,
} from '../../../_metronic/helpers'
import FeatureGate from '../../components/FeatureGate'
import { FEATURE_KEYS } from '../../features/featureRegistry'
import Button from '../../components/Button/Button'
import roleContext from '../../context/roleContext'
import { setupAxios, useAuth } from '../../modules/auth'
import { RoleContextValue } from '../../types/OtherTypes'
import CreateUser from './CreateUser'
import BulkUserUpload from './components/BulkUserUpload'
import { getPartnerUser } from './UserFunction'
import { api } from '../../../api/APIMiddlewares'
import API from '../../../api/APIUrl'
import { getProbationaryUsers, getFullTimeUsers, updateEmploymentStatus, bulkUpdateWorkingShift } from '../../../api/AdminAPI'
import { getWorkingShifts } from '../../../api/WorkingShiftAPI'
import { differenceInCalendarDays } from 'date-fns'
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { getEmploymentTypeData } from '../../CommonFunction'

const User = () => {
  const [isCreateUserModalOpen, setIsCreateUserModalOpen] = useState(false)
  const { currentUser } = useAuth()
  //const [activeTab, setActiveTab] = useState('Full-Time')
  const [activeTab, setActiveTab] = useState(() => currentUser?.isRmOrHr ? 'All' : 'Active')
  const [manageModal, setManageModal] = useState<{ open: boolean; user: any | null }>({ open: false, user: null })
  const location = useLocation()
  const [search, setSearch] = useState('')
  const [employmentTypeFilter, setEmploymentTypeFilter] = useState('')
  const [employmentTypes, setEmploymentTypes] = useState<{ label: string; value: string }[]>([])

  // Multi-select state for bulk operations
  const [selectedUsers, setSelectedUsers] = useState<Set<string>>(new Set())
  const [selectAllOnPage, setSelectAllOnPage] = useState(false)

  // Working shift modal state
  const [workingShiftModal, setWorkingShiftModal] = useState(false)
  const [workingShifts, setWorkingShifts] = useState<{ id: string; shiftName: string; startTime: string; endTime: string }[]>([])
  const [selectedShiftId, setSelectedShiftId] = useState<string | null>(null)
  const [bulkUpdateLoading, setBulkUpdateLoading] = useState(false)
  const handleTabClick = (tab) => {
    if (tab === 'All') setEmploymentTypeFilter('')
    if (tab === activeTab) {
      if (tab === 'All') setActivePage(1)
      return
    }
    setActiveTab(tab)
    setActivePage(1)
    // setSearch('')
    // Clear selections when switching tabs
    setSelectedUsers(new Set())
    setSelectAllOnPage(false)
  }

  const clearUserFilters = () => {
    setSearch('')
    setEmploymentTypeFilter('')
    setActiveTab('Active')
    setActivePage(1)
    setSelectedUsers(new Set())
    setSelectAllOnPage(false)
  }

  // Toggle individual user selection
  const toggleUserSelection = (userId: string) => {
    setSelectedUsers((prev) => {
      const newSet = new Set(prev)
      if (newSet.has(userId)) {
        newSet.delete(userId)
      } else {
        newSet.add(userId)
      }
      return newSet
    })
  }

  // Toggle select all on current page
  const toggleSelectAllOnPage = () => {
    if (selectAllOnPage) {
      // Deselect all on current page
      const currentPageIds = new Set(displayItems.map((u: any) => u.id))
      setSelectedUsers((prev) => {
        const newSet = new Set(prev)
        currentPageIds.forEach((id) => newSet.delete(id))
        return newSet
      })
      setSelectAllOnPage(false)
    } else {
      // Select all on current page
      const currentPageIds = displayItems.map((u: any) => u.id)
      setSelectedUsers((prev) => {
        const newSet = new Set(prev)
        currentPageIds.forEach((id) => newSet.add(id))
        return newSet
      })
      setSelectAllOnPage(true)
    }
  }

  // Open working shift modal
  const openWorkingShiftModal = async () => {
    try {
      const res = await getWorkingShifts(false)
      if (res?.statusCode === 200) {
        console.log(['All Shifts from API: ', res.data.length, res.data])
        setWorkingShifts([...res.data])
      } else {
        setWorkingShifts([])
      }
      setWorkingShiftModal(true)
      setSelectedShiftId(null)
    } catch (error) {
      console.error('Error fetching working shifts:', error)
      setWorkingShifts([])
    }
  }

  // Handle bulk working shift update
  const handleBulkWorkingShiftUpdate = async () => {
    if (!selectedShiftId || selectedUsers.size === 0) {
      Message('Please select a working shift and at least one user', 'error')
      return
    }

    setBulkUpdateLoading(true)
    try {
      const userIds = Array.from(selectedUsers)
      const res = await bulkUpdateWorkingShift(userIds, selectedShiftId)

      if (res.statusCode === 200) {
        Message(res.message || `Successfully updated working shift for ${userIds.length} user(s)`, 'success')
        setWorkingShiftModal(false)
        setSelectedUsers(new Set())
        setSelectAllOnPage(false)
        setSelectedShiftId(null)
        fetchUsers()
      } else {
        Message(res.message || 'Failed to update working shifts', 'error')
      }
    } catch (error: any) {
      console.error('Error updating working shifts:', error)
      Message(error?.message || 'Failed to update working shifts', 'error')
    } finally {
      setBulkUpdateLoading(false)
    }
  }
  const [activePage, setActivePage] = useState(1)
  useEffect(() => { getEmploymentTypeData(setEmploymentTypes) }, [])
  const [rowsPerPage, setRowsPerPage] = useState<number>(() => {
    const saved = sessionStorage.getItem('users_rows_per_page')
    const parsed = saved ? parseInt(saved) : 10
    return [10, 25, 50, 100].includes(parsed) ? parsed : 10
  })
  const [sortBy, setSortBy] = useState<string>('createdAt')
  const [sortDir, setSortDir] = useState<'asc' | 'desc'>('desc')
  const serverSortableKeys = useMemo(() => new Set(['firstName', 'lastName', 'email', 'mobile', 'createdAt', 'joiningDate', 'status']), [])
  const clientSortableKeys = useMemo(() => new Set(['designation', 'employment', 'role']), [])
  const cycleSort = (key: string) => {
    if (sortBy !== key) {
      setSortBy(key)
      setSortDir('asc')
      setActivePage(1)
      return
    }
    if (sortDir === 'asc') {
      setSortDir('desc')
      setActivePage(1)
      return
    }
    // Reset to default (no sort on this column)
    setSortBy('createdAt')
    setSortDir('desc')
    setActivePage(1)
  }
  let roleState: RoleContextValue = useContext(roleContext)

  // Check if user can perform bulk operations (Admin, Super Admin, HR, RM)
  const canBulkUpdate = useMemo(() => {
    return currentUser?.isAdmin === true ||
      currentUser?.isRmOrHr === true ||
      checkRole(['Users Registration', 'Roles', 'General Config'], roleState.features)
  }, [currentUser, roleState.features])

  const [user, setUser] = useState<{
    items: {
      id: string
      firstName: string
      middleName?: string
      lastName: string
      email: string
      mobile: string
      password: string
      dob: string
      gender: string
      employment: string
      employmentStatus?: string
      designation: string
      employeeCode?: string
      startDate: string
      endDate: string
      joiningDate?: string
      probationEndDate?: string
      userRoles: string[]
      inTime: string
      outTime: string
      reportingManager: {
        firstName: string
        lastName: string
      }
      hrManager: {
        firstName: string
        lastName: string
      }
      associates: {
        associateType: string
        userAssociate: { id: string; firstName: string; lastName: string }
      }[]
      personalEmail: string
      salaryStrucutre: string
    }[]

    limit: number
    page: number
    total: number
  }>({ items: [], limit: 10, page: 1, total: 0 })
  const [APIStatus, setAPIStatus] = useState({
    loading: false,
    error: null,
  })
  const [isBulkUploadOpen, setIsBulkUploadOpen] = useState(false)
  // Debounced live search (reset to page 1)
  useEffect(() => {
    // if (!search) return
    const handler = setTimeout(() => {
      setActivePage(1)
      fetchUsers()
    }, 400)
    return () => clearTimeout(handler)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search, activeTab, employmentTypeFilter])

  // Sync tab from query param (?tab=Probationary|Full-Time)
  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const tab = params.get('tab')
    if (tab && ['All', 'Active', 'Inactive', 'Probationary', 'Full-Time'].includes(tab)) {
      setActiveTab(tab)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  useEffect(() => {
    if (currentUser?.isRmOrHr && activeTab === 'Active') setActiveTab('All')
  }, [currentUser?.isRmOrHr, activeTab])
  const getUser = (setUser: Function, setAPIStatus: Function, page: number, status: string) => {
    let { token, tenantId } = setupAxios()
    setAPIStatus((prev: any) => ({ ...prev, loading: true }))
    const baseUrl = `/${API.USER}?preset=full&page=${page}&limit=${rowsPerPage}&status=${status}`
    const searchParam = search ? `&search=${encodeURIComponent(search)}` : ''
    const employmentTypeParam = employmentTypeFilter ? `&employmentTypeId=${encodeURIComponent(employmentTypeFilter)}` : ''
    const sortParams = serverSortableKeys.has(sortBy)
      ? `&sortBy=${encodeURIComponent(sortBy)}&sort=${encodeURIComponent(sortDir)}`
      : ''

    api
      .get(
        `${baseUrl}${searchParam}${employmentTypeParam}${sortParams}`,
        token,
        tenantId,
        false
      )
      .then((res) => {
        if (res.statusCode === 200) {
          setUser(res?.data)
          setAPIStatus((prev: any) => ({ ...prev, loading: false, error: null }))
        } else {
          setUser({ items: [], limit: 10, page: 1, total: 0 })
          setAPIStatus((prev: any) => ({ ...prev, loading: false, error: res.message }))
        }
      })
      .catch((error) => {
        // Handle error silently or use proper error handling
      })
  }
  const fetchUsers = () => {
    // Map tabs to backend status parameters for employment status filtering
    // Backend expects lowercase 'probationary' or 'fulltime' to trigger employment status filtering
    const statusParam = activeTab === 'Full-Time' ? 'fulltime' : activeTab === 'Probationary' ? 'probationary' : activeTab
    return getUser(setUser, setAPIStatus, activePage, statusParam)
  }


  //----------------------------------------------------
  //Export Only 10 Records
  // const handleExportUsers = () => {
  // if (!displayItems || displayItems.length === 0) {
  //   Message("No users available to export", "error");
  //   return;
  // }

  // const exportData = displayItems.map((u: any) => {
  //   const rm = u.associates?.find((a: any) => a.associateType === "RM");
  //   const hr = u.associates?.find((a: any) => a.associateType === "HR");

  //   return {
  //     Name: `${changeTextCamal(u.firstName)} ${changeTextCamal(u.lastName)}`,
  //     Contact: u.mobile ? `+91${u.mobile}` : "-",
  //     Designation: changeTextCamal(u.designation),
  //     "Employment Type": changeTextCamal(u.employment),
  //     "Employee Code": u.employeeCode || "-",
  //     "Reporting Manager": rm
  //       ? `${changeTextCamal(rm.userAssociate.firstName)} ${changeTextCamal(
  //           rm.userAssociate.lastName
  //         )}`
  //       : "-",
  //     "Human Resource": hr
  //       ? `${changeTextCamal(hr.userAssociate.firstName)} ${changeTextCamal(
  //           hr.userAssociate.lastName
  //         )}`
  //       : "-",
  //   };
  // });

  //   const worksheet = XLSX.utils.json_to_sheet(exportData);

  //   const workbook = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(workbook, worksheet, "Users");

  //   const excelBuffer = XLSX.write(workbook, {
  //     bookType: "xlsx",
  //     type: "array",
  //   });

  //   const blob = new Blob([excelBuffer], {
  //     type: "application/octet-stream",
  //   });

  //   saveAs(blob, `${activeTab}_Users.xlsx`);
  // };
//--------------------------------------------------------
//-------------------------All Active Record Download-------------------------------
const handleExportUsers = async () => {
  try {
    const { token, tenantId } = setupAxios()

    // Map tabs to backend status parameters for employment status filtering
    // Backend expects lowercase 'probationary' or 'fulltime' to trigger employment status filtering
    const statusParam =
      activeTab === "Full-Time"
        ? "fulltime"
        : activeTab === "Probationary"
        ? "probationary"
        : activeTab

    // Fetch ALL users
    const res = await api.get(
      `/${API.USER}?preset=full&page=1&limit=10000&status=${statusParam}`,
      token,
      tenantId,
      false
    )

    if (res.statusCode !== 200) {
      Message("Failed to export users", "error")
      return
    }

    const allUsers = res.data.items || []

    if (allUsers.length === 0) {
      Message("No users available to export", "error")
      return
    }

    // const exportData = allUsers.map((u: any) => {
    //   const rm = u.associates?.find((a: any) => a.associateType === "RM")
    //   const hr = u.associates?.find((a: any) => a.associateType === "HR")

    //   return {
    //     Name: `${changeTextCamal(u.firstName)} ${changeTextCamal(u.lastName)}`,
    //     Contact: u.mobile ? `+91${u.mobile}` : "-",
    //     Designation: changeTextCamal(u.designation),
    //     "Employment Type": changeTextCamal(u.employment),
    //     "Employee Code": u.employeeCode || "-",
    //     "Reporting Manager": rm
    //       ? `${changeTextCamal(rm.userAssociate.firstName)} ${changeTextCamal(
    //           rm.userAssociate.lastName
    //         )}`
    //       : "-",
    //     "Human Resource": hr
    //       ? `${changeTextCamal(hr.userAssociate.firstName)} ${changeTextCamal(
    //           hr.userAssociate.lastName
    //         )}`
    //       : "-",
    //   }
    // })
    const exportData = allUsers.map((u: any) => {
  const rm = u.associates?.find((a: any) => a.associateType === "RM")
  const hr = u.associates?.find((a: any) => a.associateType === "HR")

  let probationEnds = "-"

  if (activeTab === "Probationary") {
    const jd = u.joiningDate ? new Date(u.joiningDate) : null
    let pe = u.probationEndDate ? new Date(u.probationEndDate) : null

    if (!pe && jd) {
      const d = new Date(jd)
      d.setMonth(d.getMonth() + 6)
      pe = d
    }

    probationEnds = pe ? pe.toLocaleDateString() : "-"
  }

  const base = {
    // Name: `${changeTextCamal(u.firstName)} ${changeTextCamal(u.lastName)}`,
    Name: [ changeTextCamal(u.firstName), u.middleName ? changeTextCamal(u.middleName) : "", changeTextCamal(u.lastName),]
      .filter(Boolean)
      .join(" "),
    Contact: u.mobile ? `+91${u.mobile}` : "-",
    Designation: changeTextCamal(u.designation),
    "Employment Type": changeTextCamal(u.employment),
    "Employee Code": u.employeeCode || "-"
  }

  if (activeTab === "Probationary") {
    return {
      ...base,
      "Probation Ends": probationEnds,
      "Reporting Manager": rm
        ? `${changeTextCamal(rm.userAssociate.firstName)} ${changeTextCamal(rm.userAssociate.lastName)}`
        : "-",
      "Human Resource": hr
        ? `${changeTextCamal(hr.userAssociate.firstName)} ${changeTextCamal(hr.userAssociate.lastName)}`
        : "-"
    }
  }

  return {
    ...base,
    "Reporting Manager": rm
      ? `${changeTextCamal(rm.userAssociate.firstName)} ${changeTextCamal(rm.userAssociate.lastName)}`
      : "-",
    "Human Resource": hr
      ? `${changeTextCamal(hr.userAssociate.firstName)} ${changeTextCamal(hr.userAssociate.lastName)}`
      : "-"
  }
})
    const worksheet = XLSX.utils.aoa_to_sheet([])

    // Title based on tab
    let title = ""

    if (activeTab === "Active") title = "Active Users"
    if (activeTab === "Inactive") title = "Inactive Users"
    if (activeTab === "Probationary") title = "Probationary Users"
    if (activeTab === "Full-Time") title = "Full Time Users"

    // Add title in first row
    XLSX.utils.sheet_add_aoa(worksheet, [[title]], { origin: "A1" })

    // Leave row 2 & 3 empty automatically
    // Add table data starting from row 4
    XLSX.utils.sheet_add_json(worksheet, exportData, {
      origin: "A4",
    })
    worksheet["!cols"] = [
      { wch: 40 }, // Name (Full Name)
      { wch: 18 }, // Contact
      { wch: 20 }, // Designation
      { wch: 15 }, // Employment Type
      { wch: 15 }, // Employee Code
      { wch: 25 }, // Reporting Manager
      { wch: 25 }, // Human Resource
    ]
    //const worksheet = XLSX.utils.json_to_sheet(exportData)
    const workbook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(workbook, worksheet, "Users")

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    })

    const blob = new Blob([excelBuffer], {
      type: "application/octet-stream",
    })

    saveAs(blob, `${activeTab}_Users.xlsx`)
  } catch (error) {
    console.error("Export error:", error)
    Message("Export failed", "error")
  }
}
//--------------------------------------------------------

  const displayItems = useMemo(() => {
    const items = user?.items || []
    if (!clientSortableKeys.has(sortBy)) return items
    const dir = sortDir === 'asc' ? 1 : -1
    const getVal = (obj: any): string => {
      if (sortBy === 'designation') return (obj?.designation || '').toString()
      if (sortBy === 'employment') return (obj?.employment || '').toString()
      if (sortBy === 'role') return (obj?.userRoles || []).join(',')
      return ''
    }
    return [...items].sort((a, b) => getVal(a).localeCompare(getVal(b)) * dir)
  }, [user?.items, sortBy, sortDir, clientSortableKeys, activeTab])
  // Refetch on tab/page/rows/sort change (server-side pagination)
  useEffect(() => {
    fetchUsers()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab, activePage, rowsPerPage, sortBy, sortDir, employmentTypeFilter])

  // Update selectAllOnPage state when displayItems or selectedUsers changes
  useEffect(() => {
    if (displayItems.length === 0) {
      setSelectAllOnPage(false)
      return
    }
    const allOnPageSelected = displayItems.every((u: any) => selectedUsers.has(u.id))
    setSelectAllOnPage(allOnPageSelected)
  }, [displayItems, selectedUsers])

  return (
    <>
      {' '}
      <div>
        <div
          // id='kt_toolbar_container'
          className={clsx('d-flex justify-content-between align-items-center mb-4')}
        >
          <div className='d-flex h-55px'>
            <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap'>
              
              {/* Added Admin also show to Full-Time,Probationary,Active, Inavtive */}
              {(currentUser?.isAdmin || roleState.roleName?.toLowerCase() === 'admin' || roleState.features.includes('super admin') || currentUser?.email?.toLowerCase() === 'admin@ctrine.com' || currentUser?.email?.toLowerCase() === 'admin@ctrine.in') ? (
                <>
                  <li className='nav-item'>
                    <Link
                      className={clsx('nav-link text-active-primary me-4', {
                        active: activeTab === 'Active',
                      })}
                      to=''
                      onClick={() => handleTabClick('Active')}
                    >
                      Active
                    </Link>
                  </li>

                  <li className='nav-item'>
                    <Link
                      className={clsx('nav-link text-active-primary me-4', {
                        active: activeTab === 'Full-Time',
                      })}
                      to=''
                      onClick={() => handleTabClick('Full-Time')}
                    >
                      Full-Time
                    </Link>
                  </li>
                  <li className='nav-item'>
                    <Link
                      className={clsx('nav-link text-active-primary me-4', {
                        active: activeTab === 'Probationary',
                      })}
                      to=''
                      onClick={() => handleTabClick('Probationary')}
                    >
                      Probationary
                    </Link>
                  </li>
                  
                  <li className='nav-item'>
                    <Link
                      className={clsx('nav-link text-active-primary me-4', {
                        active: activeTab === 'Inactive',
                      })}
                      to=''
                      onClick={() => handleTabClick('Inactive')}
                    >
                      Inactive
                    </Link>
                  </li>
                </>
              ) : currentUser?.isRmOrHr ? (
                <>
                  <li className='nav-item'>
                    <Link
                      className={clsx('nav-link text-active-primary me-4', {
                        active: activeTab === 'All',
                      })}
                      to=''
                      onClick={() => handleTabClick('All')}
                    >
                      All
                    </Link>
                  </li>
                  <li className='nav-item'>
                    <Link
                      className={clsx('nav-link text-active-primary me-4', {
                        active: activeTab === 'Full-Time',
                      })}
                      to=''
                      onClick={() => handleTabClick('Full-Time')}
                    >
                      Full-Time
                    </Link>
                  </li>
                  <li className='nav-item'>
                    <Link
                      className={clsx('nav-link text-active-primary me-4', {
                        active: activeTab === 'Probationary',
                      })}
                      to=''
                      onClick={() => handleTabClick('Probationary')}
                    >
                      Probationary
                    </Link>
                  </li>
                </>
              ) : (
                <>
                  <FeatureGate feature={FEATURE_KEYS.users_active_list}>
                    <li className='nav-item'>
                      <Link
                        className={clsx('nav-link text-active-primary me-4', {
                          active: activeTab === 'Active',
                        })}
                        to=''
                        onClick={() => handleTabClick('Active')}
                      >
                        Active
                      </Link>
                    </li>
                  </FeatureGate>

                  <FeatureGate feature={FEATURE_KEYS.users_inactive_list}>
                    <li className='nav-item'>
                      <Link
                        className={clsx('nav-link text-active-primary me-4', {
                          active: activeTab === 'Inactive',
                        })}
                        to=''
                        onClick={() => handleTabClick('Inactive')}
                      >
                        Inactive
                      </Link>
                    </li>
                  </FeatureGate>
                </>
              )}
            </ul>
          </div>
          <div className='d-flex align-items-center me-5'>
            <input
              type='text'
              className='form-control form-control-sm'
              placeholder='Search users...'
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  setActivePage(1)
                  fetchUsers()
                }
              }}
              style={{ width: '260px' }}
            />
            <select
              aria-label='Filter by employment type'
              className='form-select form-select-sm ms-2'
              style={{ width: '220px' }}
              value={employmentTypeFilter}
              onChange={(e) => {
                setEmploymentTypeFilter(e.target.value)
                setActivePage(1)
              }}
            >
              <option value=''>All Employment Types</option>
              {employmentTypes.map((item) => <option key={item.value} value={item.value}>{item.label}</option>)}
            </select>
            <button
              type='button'
              className='btn btn-sm btn-light ms-2'
              disabled={!search && !employmentTypeFilter && activeTab === 'Active'}
              onClick={clearUserFilters}
            >
              Clear Filters
            </button>
            {/* Search button removed; live search triggers on typing */}
          </div>
        </div>
      </div>
      <KTCard>
        <div className='card-header'>
          <div className='card-title'>{activeTab} Users</div>
          <div className='card-toolbar'>
            <div className='d-flex justify-content-end align-items-center' data-kt-user-table-toolbar='base'>
              {/* Bulk Update Working Shift Button */}
              {/* {canBulkUpdate && selectedUsers.size > 0 && (
                <Button
                  variant='warning'
                  size='sm'
                  leftIcon={<i className='fas fa-clock'></i>}
                  onClick={openWorkingShiftModal}
                  className='me-2'
                >
                  Update Shift ({selectedUsers.size} selected)
                </Button>
              )} */}
              {canBulkUpdate && selectedUsers.size > 0 && (
                <Button
                  variant='light'
                  size='sm'
                  onClick={() => {
                    setSelectedUsers(new Set())
                    setSelectAllOnPage(false)
                  }}
                  className='me-2'
                >
                  Clear Selection
                </Button>
              )}
              <FeatureGate feature={FEATURE_KEYS.users_list}>
                {/* <Button
                  variant='secondary'
                  size='sm'
                  leftIcon={<i className='fas fa-file-upload'></i>}
                  hidden={activeTab === 'Inactive'}
                  onClick={() => setIsBulkUploadOpen(true)}
                  className='me-2'
                >
                  Upload Users (Excel/CSV)
                </Button> */}
                <Button
                  variant='primary'
                  size='sm'
                  leftIcon={<i className='fas fa-plus'></i>}
                  hidden={activeTab === 'Inactive'}
                  onClick={() => {
                    setIsCreateUserModalOpen(true)
                  }}
                  className="me-2"
                >
                  Add User
                </Button>

                <Button
                  variant='primary'
                  size="sm"
                  leftIcon={<i className="fas fa-file-excel me-2"></i>}
                  onClick={handleExportUsers}
                  className="me-2"
                >
                  Export to Excel
                </Button>
              </FeatureGate>
            </div>
          </div>
        </div>
        <KTCardBody className='py-4'>
          <div className='table-responsive'>
            {APIStatus.loading ? (
              <Center>
                {/* Render your loading spinner or indicator here */}
                <Loader />
              </Center>
            ) : (
              <table
                id='kt_table_users'
                className='table align-middle table-row-dashed fs-6 dataTable'
              >
                <thead className=' text-muted fw-bolder fs-7 text-uppercase gs-0 text-start'>
                  <tr>
                    {canBulkUpdate && (
                      <th style={{ width: '50px' }}>
                        <Checkbox
                          checked={selectAllOnPage && displayItems.length > 0}
                          indeterminate={selectedUsers.size > 0 && !selectAllOnPage}
                          onChange={toggleSelectAllOnPage}
                          title='Select all on this page'
                        />
                      </th>
                    )}
                    <th></th>
                    <th role='button' title='Click to sort' onClick={() => cycleSort('firstName')}>
                      Name {sortBy === 'firstName' ? (sortDir === 'asc' ? '↑' : '↓') : ''}
                    </th>
                    <th role='button' title='Click to sort' onClick={() => cycleSort('mobile')}>
                      Contact {sortBy === 'mobile' ? (sortDir === 'asc' ? '↑' : '↓') : ''}
                    </th>
                    <th role='button' title='Click to sort' onClick={() => cycleSort('designation')}>
                      Designation {sortBy === 'designation' ? (sortDir === 'asc' ? '↑' : '↓') : ''}
                    </th>
                    <th role='button' title='Click to sort' onClick={() => cycleSort('employment')}>
                      Employment Type {sortBy === 'employment' ? (sortDir === 'asc' ? '↑' : '↓') : ''}
                    </th>
                    <th role='button' title='Click to sort' onClick={() => cycleSort('employeeCode')}>
                      Employee Code {sortBy === 'employeeCode' ? (sortDir === 'asc' ? '↑' : '↓') : ''}
                    </th>
                    {/* {activeTab === 'Probationary' ? (
                      <th>Probation Ends</th>
                    ) : (
                      <>
                        <th>Reporting Manager</th>
                        <th>Human Resource</th>
                      </>
                    )} */}
                    {activeTab === 'Probationary' && <th>Probation Ends</th>}
<th>Reporting Manager</th>
<th>Human Resource</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                {displayItems?.length > 0 ? (
                  <tbody className='text-gray-800 fw-semibold text-left'>
                    {displayItems?.map((obj) => {
                      return (
                        <tr key={obj?.id}>
                          {canBulkUpdate && (
                            <td>
                              <Checkbox
                                checked={selectedUsers.has(obj?.id)}
                                onChange={() => toggleUserSelection(obj?.id)}
                              />
                            </td>
                          )}
                          <td className='symbol symbol-45px'>
                            <img
                              src={toAbsoluteUrl('/media/avatars/blank.png')}
                              alt='user profile'
                            />
                          </td>
                          {/* <td style={{ minWidth: '70px', paddingLeft: '10px' }}>
                            {changeTextCamal(obj?.firstName), } {changeTextCamal(obj?.lastName)}{' '}
                            <br />
                            <a
                              className='fs-7'
                              href={`mailto:${obj?.email}`}
                              target='_blank'
                              rel='noopener noreferrer'
                            >
                              {obj?.email}
                            </a>
                          </td> */}
                          <td style={{ minWidth: '70px', paddingLeft: '10px' }}>
                            {[
                              changeTextCamal(obj?.firstName),
                              obj?.middleName ? changeTextCamal(obj?.middleName) : '',
                              changeTextCamal(obj?.lastName),
                            ]
                              .filter(Boolean)
                              .join(' ')}
                            <br />
                            <a
                              className='fs-7'
                              href={`mailto:${obj?.email}`}
                              target='_blank'
                              rel='noopener noreferrer'
                            >
                              {obj?.email}
                            </a>
                          </td>

                          <td>{`${obj?.mobile ? '+91' + obj.mobile : '-'}`}</td>

                          <td>{changeTextCamal(obj?.designation)}</td>
                          <td>{changeTextCamal(obj?.employment)}</td>
                          <td style={{ fontSize: '12px', wordBreak: 'break-all' }}>{obj?.employeeCode || '-'}</td>
                          {/* {activeTab === 'Probationary' ? (
                            <td>
                              {(() => {
                                const now = new Date();
                                const jd = obj.joiningDate ? new Date(obj.joiningDate) : null as any;
                                let pe = obj.probationEndDate ? new Date(obj.probationEndDate) : null as any;
                                if (!pe && jd) {
                                  const d = new Date(jd);
                                  d.setMonth(d.getMonth() + 6);
                                  pe = d;
                                }
                                if (!pe) return '-';
                                const days = Math.ceil((pe.getTime() - now.getTime()) / (1000 * 60 * 60 * 24));
                                if (days <= 30 && days >= 0) {
                                  return (
                                    <span className='badge badge-light-warning'>
                                      {pe.toLocaleDateString()} ({days} days)
                                    </span>
                                  );
                                }
                                return '-';
                              })()}
                            </td>
                          ) : (
                            <>
                              <td style={{ minWidth: '70px', paddingLeft: '10px' }}>
                                {obj.associates.some((item) => item.associateType === 'RM') ? (
                                  <span>
                                    {obj.associates?.map((associate) =>
                                      associate.associateType === 'RM' ? (
                                        <>
                                          {changeTextCamal(associate?.userAssociate?.firstName)}{' '}
                                          {changeTextCamal(associate?.userAssociate?.lastName)}
                                        </>
                                      ) : (
                                        ''
                                      )
                                    )}
                                  </span>
                                ) : (
                                  '-'
                                )}
                              </td>
                              <td>
                                {obj.associates.some((item) => item.associateType === 'HR') ? (
                                  <span>
                                    {obj.associates?.map((associate) =>
                                      associate.associateType === 'HR' ? (
                                        <>
                                          {changeTextCamal(associate?.userAssociate?.firstName)}{' '}
                                          {changeTextCamal(associate?.userAssociate?.lastName)}
                                        </>
                                      ) : (
                                        ''
                                      )
                                    )}
                                  </span>
                                ) : (
                                  '-'
                                )}
                              </td>
                            </>
                          )} */}
                          {activeTab === 'Probationary' && (
  <td>
    {(() => {
      const now = new Date();
      const jd = obj.joiningDate ? new Date(obj.joiningDate) : null as any;
      let pe = obj.probationEndDate ? new Date(obj.probationEndDate) : null as any;

      if (!pe && jd) {
        const d = new Date(jd);
        d.setMonth(d.getMonth() + 6);
        pe = d;
      }

      if (!pe) return '-';

      const days = Math.ceil((pe.getTime() - now.getTime()) / (1000 * 60 * 60 * 24));

      if (days <= 30 && days >= 0) {
        return (
          <span className='badge badge-light-warning'>
            {pe.toLocaleDateString()} ({days} days)
          </span>
        );
      }

      return '-';
    })()}
  </td>
)}

<td style={{ minWidth: '70px', paddingLeft: '10px' }}>
  {obj.associates.some((item) => item.associateType === 'RM') ? (
    obj.associates.map((associate) =>
      associate.associateType === 'RM'
        ? `${changeTextCamal(associate?.userAssociate?.firstName)} ${changeTextCamal(associate?.userAssociate?.lastName)}`
        : ''
    )
  ) : (
    '-'
  )}
</td>

<td>
  {obj.associates.some((item) => item.associateType === 'HR') ? (
    obj.associates.map((associate) =>
      associate.associateType === 'HR'
        ? `${changeTextCamal(associate?.userAssociate?.firstName)} ${changeTextCamal(associate?.userAssociate?.lastName)}`
        : ''
    )
  ) : (
    '-'
  )}
</td>

                          {/* Actions */}
                          <td>
                            <div className='d-flex justify-content-center flex-shrink-0'>
                              {/* Existing actions */}
                              <Link
                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                to={`/profile/${obj?.id}`}
                              >
                                <i className='fas fa-eye'></i>
                              </Link>

                              {/* HR/Admin probation manage modal trigger */}
                              {['Probationary'].includes(activeTab) && (
                                (obj.associates?.some((a: any) => a.associateType === 'HR' && currentUser?.id && a.userAssociate && a.userAssociate.id === currentUser.id)) ||
                                (currentUser?.isAdmin === true) ||
                                (checkRole(['Users Registration', 'Roles', 'General Config'], roleState.features))
                              ) && (
                                  <>
                                    {typeof (obj as any).remainingDays === 'number' && (obj as any).remainingDays <= 30 && (
                                      <span className='badge badge-light-warning me-2'>
                                        {(obj as any).remainingDays} days left
                                      </span>
                                    )}
                                    <button className='btn btn-sm btn-primary' onClick={() => setManageModal({ open: true, user: obj })}>
                                      Manage
                                    </button>
                                  </>
                                )}
                            </div>
                          </td>
                        </tr>
                      )
                    })}
                  </tbody>
                ) : (
                  <tbody>
                    <tr>
                      <td colSpan={canBulkUpdate ? 10 : 9}>
                        <Center>
                          <Text>No users found</Text>
                        </Center>
                      </td>
                    </tr>
                  </tbody>
                )}
              </table>
            )}
          </div>
          <div className='d-flex mt-4'>
            <Text className='me-auto'>
              {getPaginationInfoData(activePage, String(rowsPerPage), user?.total?.toString() ?? '', {
                data: user?.items ?? '',
              })}{' '}
              Of {Math.ceil(Number(user?.total ?? 0))}
            </Text>
            <div className='d-flex align-items-center gap-3'>
              <div className='d-flex align-items-center'>
                <span className='me-2'>Rows:</span>
                <select
                  className='form-select form-select-sm'
                  value={rowsPerPage}
                  onChange={(e) => {
                    const val = parseInt(e.target.value)
                    sessionStorage.setItem('users_rows_per_page', String(val))
                    setRowsPerPage(val)
                    setActivePage(1)
                  }}
                >
                  {[10, 25, 50, 100].map((n) => (
                    <option key={n} value={n}>{n}</option>
                  ))}
                </select>
              </div>
              <Pagination
                value={activePage}
                size='lg'
                styles={(theme) => ({
                  control: {
                    '&[data-active]': {
                      backgroundImage: theme.colorScheme,
                    },
                  },
                })}
                onChange={(page) => {
                  setActivePage(page)
                  // Use properly mapped status instead of raw activeTab
                  const statusParam = activeTab === 'Full-Time' ? 'Full-Time' : activeTab === 'Probationary' ? 'Probationary' : activeTab
                  getUser(setUser, setAPIStatus, page, statusParam)
                }}
                total={Math.ceil(Number(user?.total ?? 0) / Number(rowsPerPage))}
              ></Pagination>
            </div>
          </div>
        </KTCardBody>
      </KTCard>
      {isCreateUserModalOpen && (
        <CreateUser
          closeModal={() => setIsCreateUserModalOpen(false)}
          user={user}
          setUser={setUser}
          fetchUsers={fetchUsers}
        />
      )}
      {isBulkUploadOpen && (
        <BulkUserUpload
          onClose={() => setIsBulkUploadOpen(false)}
          onUploaded={() => {
            setIsBulkUploadOpen(false)
            fetchUsers()
          }}
        />
      )}
      {manageModal.open && (
        <div className='modal fade show d-block' tabIndex={-1}>
          <div className='modal-dialog'>
            <div className='modal-content'>
              <div className='modal-header'>
                <h5 className='modal-title'>Manage Probation</h5>
                <button type='button' className='btn-close' onClick={() => setManageModal({ open: false, user: null })}></button>
              </div>
              <div className='modal-body'>
                <p className='mb-4'>Choose an action for {changeTextCamal(manageModal.user?.firstName)} {changeTextCamal(manageModal.user?.lastName)}</p>
                <div className='d-flex gap-3'>
                  <label className='btn btn-light-primary'>
                    <i className='fas fa-upload me-1'></i> Convert to Full-Time (upload docs)
                    <input type='file' hidden accept='.pdf,.doc,.docx' onChange={async (e) => {
                      const file = e.target.files?.[0]
                      if (!file) return
                      const res = await updateEmploymentStatus(manageModal.user.id, 'FULL_TIME', file)
                      if (res.statusCode === 200) {
                        Message('User marked Full-Time', 'success')
                        setManageModal({ open: false, user: null })
                        fetchUsers()
                      } else {
                        Message(res.message || 'Failed', 'error')
                      }
                      try { if (e.currentTarget) e.currentTarget.value = '' } catch { }
                    }} />
                  </label>
                  <button className='btn btn-light-danger' onClick={async () => {
                    const res = await updateEmploymentStatus(manageModal.user.id, 'LAID_OFF')
                    if (res.statusCode === 200) {
                      Message('User marked Laid-Off', 'success')
                      setManageModal({ open: false, user: null })
                      fetchUsers()
                    } else {
                      Message(res.message || 'Failed', 'error')
                    }
                  }}>
                    <i className='fas fa-user-slash me-1'></i> Lay Off
                  </button>
                </div>
              </div>
              <div className='modal-footer'>
                <button className='btn btn-secondary' onClick={() => setManageModal({ open: false, user: null })}>Close</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Bulk Update Working Shift Modal */}
      <Modal
        opened={workingShiftModal}
        onClose={() => {
          setWorkingShiftModal(false)
          setSelectedShiftId(null)
        }}
        title={
          <div>
            <h5 className='mb-1'>Update Working Shift</h5>
            <small className='text-muted'>
              {selectedUsers.size} user(s) selected
            </small>
          </div>
        }
        size='md'
        centered
      >
        <div className='mb-4'>
          <p className='text-muted mb-3'>
            Select a working shift to apply to all selected users. This will update their shift timing.
          </p>

          <Select
            label='Working Shift'
            placeholder='Select a working shift'
            value={selectedShiftId}
            onChange={(value) => setSelectedShiftId(value)}
            data={workingShifts.map((shift) => ({
              value: shift.id,
              label: `${shift.shiftName} (${shift.startTime} - ${shift.endTime})`,
            }))}
            searchable
            clearable
            maxDropdownHeight={300}
            withinPortal
            nothingFound='No working shifts found'
          />

          {selectedShiftId && (
            <div className='mt-3 p-3 bg-light rounded'>
              <small className='text-muted'>Selected shift details:</small>
              {(() => {
                const shift = workingShifts.find((s) => s.id === selectedShiftId)
                if (!shift) return null
                return (
                  <div className='mt-2'>
                    <strong>{shift.shiftName}</strong>
                    <br />
                    <span className='text-muted'>
                      <i className='fas fa-clock me-1'></i>
                      {shift.startTime} - {shift.endTime}
                    </span>
                  </div>
                )
              })()}
            </div>
          )}
        </div>

        <div className='d-flex justify-content-end gap-2'>
          <Button
            variant='light'
            onClick={() => {
              setWorkingShiftModal(false)
              setSelectedShiftId(null)
            }}
          >
            Cancel
          </Button>
          <Button
            variant='primary'
            onClick={handleBulkWorkingShiftUpdate}
            disabled={!selectedShiftId || bulkUpdateLoading}
            loading={bulkUpdateLoading}
          >
            Update {selectedUsers.size} User(s)
          </Button>
        </div>
      </Modal>
    </>
  )
}

export default User
